import React, { useEffect, useState } from "react";
import Sidebar from "../../../../components/user/defaultLayout/Sidebar";
import Index from "../../../../container/Index";
import { useTheme } from "@mui/material/styles";
import OutlinedInput from "@mui/material/OutlinedInput";
import PagesIndex from "../../../PagesIndex";
import RemoveIcon from "@mui/icons-material/Remove";
import moment from "moment";
import dayjs from "dayjs";

import * as yup from "yup";
import {
  getFamilyIds,
  getSahayTypeList,
  getSahaySubTypeList,
  getFamilyMemberById,
  applyForSahayAPI,
  listYearOfSahay,
  // bankAccountsList,
  getRelationMasterList,
  updateApplyForSahayDocuments,
  getAllFamilyWithMohollaNameAndAreaList,
  getSahayWiseDonnerList,
  getCheckAuthenticationDocument,
  getSahayApplicatOldBankDetail,
} from "../../../../redux/features/AddService";
import {
  validationSchemaApplyForSahayBankMemberUser,
  validationSchemaApplyForSahayUser,
  validationSchemaSave,
} from "../../../../validation/Validation";
import { Autocomplete, Typography } from "@mui/material";
import DataService, { imagePath } from "../../../../config/DataService";
import { Api } from "../../../../config/Api";
import { toast } from "react-toastify";
import { FieldArray } from "formik";
import { sahayDocumentArray } from "../../../admin/pages/AddSahayAplicationAdmin/DocumentsPermissions";
import AfterSumitFormModal from "../../../../components/common/modalAfterSubmitForm/ModalAfterSubmit";
import axios from "axios";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const ariaLabel = { "aria-label": "description" };

const familyIncomeAmountList = [
  { id: 1, ammount: "Less than 5 Lakh" },
  { id: 2, ammount: "5 Lakh or Above" },
];

const electricBillAmountList = [
  { id: 1, ammount: "0 to 1000" },
  { id: 2, ammount: "1001 to 2500" },
  { id: 3, ammount: "2501 to 3500" },
  { id: 4, ammount: "3501 and Above" },
];
const workingTypeList = [
  { id: 1, name: "Business" },
  { id: 2, name: "House Wife" },
  { id: 3, name: "Job" },
  { id: 4, name: "Retire" },
  { id: 5, name: "Student" },
  { id: 6, name: "Not Applicable" },
];

const EditApplyForSahay = () => {
  const { state } = PagesIndex.useLocation();
  const [editData, setEditData] = useState({});
  const [loading, setLoading] = useState(false);

  const listingData = state?.row;

  const {
    getUserLoginDetails,

    getRelationList,
  } = PagesIndex.useSelector((state) => state.admin);

  const dispatch = PagesIndex.useDispatch();
  const navigate = PagesIndex.useNavigate();

  //all state

  const [listYearOfSahayData, setListYearOfSahayData] = useState([]);
  const [bankAccountsListData, setBankAccountsListData] = useState([]);
  const [applicantId, setApplicantId] = useState();

  const [sahayTypeList, setSahayTypeList] = useState();
  const [sahaySubTypeList, setSahaySubTypeList] = useState();
  const [familyMembers, setFamilyMembers] = useState();
  const [selectedImage, setSelectedImage] = useState();

  const [sahayCondition, setSahayCondition] = useState();
  const [singlaFamilyId, setSingleFamilyId] = useState();
  const [singlaMohallaName, setSingleMohallaName] = useState();

  const [getSingleSubSahay, setGetSingleSubSahay] = useState();
  const [applicantSelectedMember, setApplicantSelectedMember] = useState([]);
  const [demoDocument, setDemoDocument] = useState("");
  const [mohallaSelectedMember, setMohallaSelectedMember] = useState("");
  const [areaSelectedMember, setAreaSelectedMember] = useState("");
  const [familyListWithArea, setFamilyListWithArea] = useState([]);
  const [loader, setLoader] = useState(false);
  const [sahayWiseDonnerList, setSahayWiseDonnerList] = useState();
  const [saveVale, setSaveValue] = useState(false);
  const [openModalAfterSubmit, setOpenModalAfterSubmit] = useState(false);
  const [mobileDataForFamily, setMobileDataForFamily] = useState("");
  const handleOpenAfterSumitModal = () => {
    setOpenModalAfterSubmit(true);
  };

  const handleCloseAftereSubmitModal = () => {
    setOpenModalAfterSubmit(false);
  };

  const handleMenuRelationOpen = () => {
    setLoader(true);

    familyListWithArea?.length > 0 &&
      setTimeout(() => {
        setLoader(false);
      }, 2000);
  };
  const handleMenuRelationClose = () => {
    setLoader(true);
    setTimeout(() => {
      setLoader(false);
    }, 2000);
  };

  const EducationSubsahayValue = [
    1015, 1017, 1010, 1007, 1006, 1008, 1009, 1010, 1011, 1012, 1013, 1019,
    1018, 1020, 1021, 1022, 1023,
  ];

  // const getFamilyMemberIds = (status) => {
  //   dispatch(getFamilyIds(status)).then((res) => {});
  // };

  const getSahayTypeData = () => {
    dispatch(getSahayTypeList()).then((res) => {
      setSahayTypeList(res?.payload);
    });
  };

  const getSahaySubTypeData = (sahayTypeId) => {
    if (sahayTypeId) {
      dispatch(getSahaySubTypeList(sahayTypeId)).then((res) => {
        setSahaySubTypeList(res?.payload);
      });
    }
  };

  const setMemberDeatils = (applicantId, setFieldValue, subSahayName) => {
    const member =
      familyMembers &&
      familyMembers?.filter((member) => member?.id == applicantId);

    if (member?.[0]) {
      setFieldValue(
        "memberName",
        member?.[0]?.firstName +
          " " +
          member?.[0]?.middleName +
          " " +
          member?.[0]?.lastName,
      );
      setFieldValue("age", member?.[0]?.age);
      setFieldValue("workingType", member?.[0]?.workingType);
      setFieldValue("relation", member?.[0]?.relation);
      setFieldValue("relation_id", member?.[0]?.relation_id);
      // setFieldValue("monthlyIncome", member?.[0]?.annualIncome);
      setFieldValue("id", member?.[0]?.id);
      setFieldValue(
        "firstNameApplicant",
        member?.[0]?.firstName + " " + member?.[0]?.lastName,
      );
      const isMediclaimPremiumSahay =
        subSahayName?.toLowerCase() === "mediclaim premium sahay";
      const isMedicalSahay =
        subSahayName?.toLowerCase() === "medical sahay";

      if (isMedicalSahay) {
        setFieldValue("familyMembersDetails", [
          {
            fullName:
              member?.[0]?.firstName +
              " " +
              member?.[0]?.middleName +
              " " +
              member?.[0]?.lastName,
            relation: "Applicant",
            age: member?.[0]?.age ? member?.[0]?.age : 0,
            sumInsured: 0,
            totalPremium: 0,
          },
        ]);
      }
      if (isMediclaimPremiumSahay) {
        setFieldValue("policyHolders", [
          {
            fullName:
              member?.[0]?.firstName +
              " " +
              member?.[0]?.middleName +
              " " +
              member?.[0]?.lastName,
            relationship: "Applicant",
            age: member?.[0]?.age ? member?.[0]?.age : 0,
            sumInsured: 0,
            totalPremium: 0,
          },
        ]);
      }
    }
  };

  const getSingleSahayApplication = async () => {
    setLoading(true);
    try {
      const response = await DataService.get(
        `${Api.GET_SINGLE_SAHAY_APPLICATION}/${listingData?.id}`,
        // `${Api.GET_SINGLE_SAHAY_APPLICATION}/${listingData?.id[0]}`
      );

      if (response?.data?.status == 200) {
        setLoading(false);
        setEditData(response.data.data);
        setSahayCondition(
          response?.data?.data?.trustRecords?.length ? "yes" : "no",
        );
      }
    } catch (error) {
      // toast.error(error.response.data.message || error.message);
    }
  };

  useEffect(() => {
    // getFamilyMemberIds(true);
    getSahayTypeData();
    dispatch(getRelationMasterList());

    getSingleSahayApplication();
    let familyId = localStorage.getItem("familyId")
      ? localStorage.getItem("familyId")
      : 0;
    const data = {
      familyId: familyId,
      VastiPatra: getUserLoginDetails?.vastipatrak,
    };
    let MohallaName = localStorage.getItem("mohollo_name")
      ? localStorage.getItem("mohollo_name")
      : "";
    setSingleMohallaName(MohallaName);
    setSingleFamilyId(familyId);
    dispatch(getFamilyMemberById(data)).then((res) => {
      setFamilyMembers(res?.payload);
    });

    dispatch(listYearOfSahay()).then((data) => {
      if (data?.payload) {
        setListYearOfSahayData(data?.payload);
      } else {
        setListYearOfSahayData([]);
      }
    });
  }, []);

  useEffect(() => {
    if (editData?.application?.[0]?.sahayTypeId !== undefined) {
      getSahaySubTypeData(editData?.application?.[0]?.sahayTypeId);
    }
  }, [editData?.application?.[0]?.sahayTypeId !== undefined]);

  const getFamilyListWithArea = () => {
    const data = {
      mobile:
        editData?.application?.[0]?.patanMemberMobile?.length >= 10
          ? editData?.application?.[0]?.patanMemberMobile
          : mobileDataForFamily,
    };

    dispatch(getAllFamilyWithMohollaNameAndAreaList(data)).then((res) => {
      if (res?.payload) {
        setFamilyListWithArea(res?.payload?.data);
      } else {
        setFamilyListWithArea([]);
      }
    });
  };

  useEffect(() => {
    if (
      mobileDataForFamily?.length >= 10 ||
      editData?.application?.[0]?.patanMemberMobile?.length >= 10
    ) {
      getFamilyListWithArea();
    }
  }, [mobileDataForFamily || editData?.application?.[0]?.patanMemberMobile]);

  const resetImage = (setFieldValue) => {
    setFieldValue("passportPic", "");
    setSelectedImage("");
  };

  let initialValues;
  if (Object.keys(editData).length) {
    initialValues = {
        familyMembersDetails:
        editData?.medicalSahay?.familyMembersDetails?.length >
        0
          ? editData?.medicalSahay?.familyMembersDetails.map(
              (member) => ({
                fullName: member?.fullName || "",
                relation: member?.relation || "",
                age: member?.age || "",
                currentActivity: member?.currentActivity || "",
                monthlyIncome: member?.monthlyIncome || "",
              }),
            )
          : [
              {
                fullName: "",
                relation: "",
                age: "",
                currentActivity: "",
                monthlyIncome: "",
              },
            ],

      totalFamilyMembers:
        editData?.medicalSahay?.totalFamilyMembers || "",
      earningMembers:
        editData?.medicalSahay?.earningMembers || "",
      mainAilmentDetails:
        editData?.medicalSahay?.mainAilmentDetails || "",
      otherAilmentsDetails:
        editData?.medicalSahay?.otherAilmentsDetails || "",
      illnessDuration:
        editData?.medicalSahay?.illnessDuration || "",
      familyDoctorName:
        editData?.medicalSahay?.familyDoctorName || "",
      familyDoctorMobile:
        editData?.medicalSahay?.familyDoctorMobile || "",
      operationPerformed:
        editData?.medicalSahay?.operationPerformed || "",
      doctorConsultantName:
        editData?.medicalSahay?.doctorConsultantName || "",
      hospitalNursingHomeName:
        editData?.medicalSahay?.hospitalNursingHomeName || "",

      // Medication Expenses
      medicationExpenses:
        editData?.medicalSahay?.medicationExpenses?.length > 0
          ? editData?.medicalSahay?.medicationExpenses.map(
              (expense) => ({
                description: expense?.description || "",
                amount: expense?.amount || "",
              }),
            )
          : [
              { description: "Medicine cost (as per bill)", amount: "" },
              { description: "Consultant fee", amount: "" },
              { description: "Report cost", amount: "" },
              { description: "Other expenses (with details)", amount: "" },
            ],

      // Hospital Treatment Expenses
      hospitalExpenses:
        editData?.medicalSahay?.hospitalExpenses?.length > 0
          ? editData?.medicalSahay?.hospitalExpenses.map(
              (expense) => ({
                description: expense?.description || "",
                amount: expense?.amount || "",
              }),
            )
          : [
              { description: "Doctor charges", amount: "" },
              { description: "Hospital bill", amount: "" },
              { description: "Equipment bill", amount: "" },
            ],

      // Hospital Details
      hospitalClass:
        editData?.medicalSahay?.hospitalClass || "",
      hospitalDays: editData?.medicalSahay?.hospitalDays || "",
      dailyCharge: editData?.medicalSahay?.dailyCharge || "",
      icuDays: editData?.medicalSahay?.icuDays || "",
      icuDailyCharge:
        editData?.medicalSahay?.icuDailyCharge || "",
      treatmentReason:
        editData?.medicalSahay?.treatmentReason || "",

      // Mediclaim Details
      mediclaimPolicyTaken:
        editData?.medicalSahay?.mediclaimPolicyTaken || "no",
      mediclaimPolicyAmount:
        editData?.medicalSahay?.mediclaimPolicyAmount || "",
      associationMediclaimTaken:
        editData?.medicalSahay?.associationMediclaimTaken ||
        "no",
      associationMediclaimAmount:
        editData?.medicalSahay?.associationMediclaimAmount ||
        "",
      mediclaimNotTakenReason:
        editData?.medicalSahay?.mediclaimNotTakenReason || "",
      mediclaimPremiumAssistance:
        editData?.medicalSahay?.mediclaimPremiumAssistance ||
        "no",
      mediclaimPremiumAmount:
        editData?.medicalSahay?.mediclaimPremiumAmount || "",
      receivedMedicineAssistanceLast12Months:
        editData?.medicalSahay
          ?.receivedMedicineAssistanceLast12Months || "no",
      medicineAssistanceAmount:
        editData?.medicalSahay?.medicineAssistanceAmount || "",

      // Known Person Details
      knownPersonFullName:
        editData?.medicalSahay?.knownPersonFullName || "",
      knownPersonResidence:
        editData?.medicalSahay?.knownPersonResidence || "",
      knownPersonNeighborhood:
        editData?.medicalSahay?.knownPersonNeighborhood || "",
      knownPersonHomePhone:
        editData?.medicalSahay?.knownPersonHomePhone || "",
      knownPersonMobile:
        editData?.medicalSahay?.knownPersonMobile || "",

      // Detailed Expense Bills - Medicine Bills
      medicineBillsDetails:
        editData?.medicalSahay?.medicineBillsDetails?.length >
        0
          ? editData?.medicalSahay?.medicineBillsDetails.map(
              (bill) => ({
                date: bill?.date || "",
                amount: bill?.amount || "",
                medicalStoreName: bill?.medicalStoreName || "",
              }),
            )
          : [
              {
                date: "",
                amount: "",
                medicalStoreName: "",
              },
            ],

      // Diagnosis Bills
      diagnosisBillsDetails:
        editData?.medicalSahay?.diagnosisBillsDetails?.length >
        0
          ? editData?.medicalSahay?.diagnosisBillsDetails.map(
              (bill) => ({
                date: bill?.date || "",
                laboratoryName: bill?.laboratoryName || "",
                amount: bill?.amount || "",
              }),
            )
          : [
              {
                date: "",
                laboratoryName: "",
                amount: "",
              },
            ],

      // Hospital Bills
      hospitalBillsDetails:
        editData?.medicalSahay?.hospitalBillsDetails?.length >
        0
          ? editData?.medicalSahay?.hospitalBillsDetails.map(
              (bill) => ({
                date: bill?.date || "",
                details: bill?.details || "",
                amount: bill?.amount || "",
              }),
            )
          : [
              {
                date: "",
                details: "",
                amount: "",
              },
            ],

      // Other Expenses
      otherExpensesDetails:
        editData?.medicalSahay?.otherExpensesDetails?.length >
        0
          ? editData?.medicalSahay?.otherExpensesDetails.map(
              (expense) => ({
                date: expense?.date || "",
                details: expense?.details || "",
                amount: expense?.amount || "",
              }),
            )
          : [
              {
                date: "",
                details: "",
                amount: "",
              },
            ],

      // External Assistance
      receivedExternalAssistance:
        editData?.medicalSahay?.receivedExternalAssistance ||
        "no",
      externalAssistanceDetails:
        editData?.medicalSahay?.externalAssistanceDetails
          ?.length > 0
          ? editData?.medicalSahay?.externalAssistanceDetails?.map(
              (assistance) => ({
                organizationName: assistance?.organizationName || "",
                amount: assistance?.amount || "",
              }),
            )
          : [
              {
                organizationName: "",
                amount: "",
              },
            ],
            // Insurance Information Fields
      insuranceCompanyName: editData
        ? editData?.application[0]?.insuranceCompanyName
        : "",
      branchNumber: editData
        ? editData?.application[0]?.branchNumber
        : "",
      policyNumber: editData
        ? editData?.application[0]?.policyNumber
        : "",
      place: editData
        ? editData?.application[0]?.place
        : "",
      totalPremiumPaid: editData
        ? editData?.application[0]?.totalPremiumPaid
        : "",
      policyTermFrom: editData
        ? editData?.application[0]?.policyTermFrom
        : "",
      policyTermTo: editData
        ? editData?.application[0]?.policyTermTo
        : "",
      lastYearAmount: editData
        ? editData?.application[0]?.lastYearAmount
        : "",
      lastYearUntilDate: editData
        ? editData?.application[0]?.lastYearUntilDate
        : "",
      policyTypeSelect: editData
        ? editData?.application[0]?.policyTypeSelect
        : "", // 'new' or 'renewal'
      claimReceived: editData
        ? editData?.application[0]?.claimReceived
        : "no", // 'yes' or 'no'
      sbiPolicyTaken: editData
        ? editData?.application[0]?.sbiPolicyTaken
        : "no", // 'yes' or 'no'
      policyReason: editData
        ? editData?.application[0]?.policyReason
        : "",
      policyCategory: editData
        ? editData?.application[0]?.policyCategory
        : "", // 'group' or 'individual'

      policyHolders:
        editData?.policyHolders?.length > 0
          ? editData?.policyHolders
          : [
              {
                fullName: "",
                relationship: "Applicant", // First row is always Applicant
                age: "",
                sumInsured: "",
                totalPremium: "",
              },
            ],

      medicalBills:
        editData?.medicalBills?.length > 0
          ? editData?.medicalBills.map((ele) => {
              return {
                storeName: ele?.storeName || "",
                date: ele?.date || "",
                amount: ele?.amount || 0,
              };
            })
          : [
              {
                storeName: "",
                date: "",
                amount: 0,
              },
            ],

      // Assistance from Other Organizations
      receivedAidFromOthers: editData
        ? editData?.application[0]?.receivedAidFromOthers
        : "no", // 'yes' or 'no'
      assistanceOrg1Name: editData
        ? editData?.application[0]?.assistanceOrg1Name
        : "",
      assistanceOrg1Amount: editData
        ? editData?.application[0]?.assistanceOrg1Amount
        : 0,
      assistanceOrg2Name: editData
        ? editData?.application[0]?.assistanceOrg2Name
        : "",
      assistanceOrg2Amount: editData
        ? editData?.application[0]?.assistanceOrg2Amount
        : 0,

      // Direct Medicine Scheme
      directMedicineSchemeJoined: editData
        ? editData?.application[0]?.directMedicineSchemeJoined
        : "no", // 'yes' or 'no'
      directMedicineSchemeReason: editData
        ? editData?.application[0]?.directMedicineSchemeReason
        : "",

      dataArray: editData
        ? editData?.trustRecords?.map((ele) => {
            return {
              trustName: ele ? ele?.trustName : "",
              ammount: ele ? ele?.ammount : 0,
              id: ele ? ele?.id : "",
            };
          })
        : [
            {
              trustName: "",
              ammount: 0,
            },
          ],
      isLoan: sahaySubTypeList?.find(
        (data) => +data?.Id == +editData?.application[0]?.subSahayTypeId,
      )?.isLoan
        ? sahaySubTypeList?.find(
            (data) => +data?.Id == +editData?.application[0]?.subSahayTypeId,
          )?.isLoan
        : "",
      patanReferenceName: editData?.application[0]?.patanReferenceName
        ? editData?.application[0]?.patanReferenceName
        : "",
      patanReferenceArea: editData?.application[0]?.patanReferenceArea
        ? editData?.application[0]?.patanReferenceArea
        : "",
      patanReferenceMohollo: editData?.application[0]?.patanReferenceMohollo
        ? editData?.application[0]?.patanReferenceMohollo
        : "",
      subSahayName: sahaySubTypeList?.find(
        (data) => +data?.Id == +editData?.application[0]?.subSahayTypeId,
      )?.SahayName
        ? sahaySubTypeList?.find(
            (data) => +data?.Id == +editData?.application[0]?.subSahayTypeId,
          )?.SahayName
        : "",
      PANCardNo:
        editData?.application[0]?.PANCardNo !== "NULL" ||
        editData?.application[0]?.PANCardNo !== ""
          ? editData?.application[0]?.PANCardNo
          : "",
      patanMandalMember: editData?.application[0]?.patanMandalMember
        ? +editData?.application[0]?.patanMandalMember
        : "",
      patanMemberMobile: editData?.application[0]?.patanMemberMobile
        ? +editData?.application[0]?.patanMemberMobile
        : "",
      vastiPatrak: "true",
      familyId: singlaFamilyId ? singlaFamilyId : "",
      AadharNo: editData ? editData?.application?.[0]?.AadharNo : "",
      SahayType: editData ? editData?.application?.[0]?.sahayTypeId : "",
      subSahayType: editData ? editData?.application?.[0]?.subSahayTypeId : "",
      // subSahayName: editData?.document[0]
      //   ? editData?.document[0]?.subSahayName
      //   : "",
      applicantId: editData ? editData?.application?.[0]?.applicantId : "",
      beneficiaryName: editData
        ? editData?.application?.[0]?.beneficiaryName
        : "",
      memberName: editData ? editData?.application?.[0]?.Name : "",
      relation: editData ? editData?.application?.[0]?.relation : "",
      relation_id: editData ? editData?.application?.[0]?.relation_id : "",
      age: editData ? editData?.application?.[0]?.age : "",
      workingType: editData ? editData?.application?.[0]?.workingType : "",
      monthlyIncome: editData ? editData?.application?.[0]?.monthlyIncome : "",
      newMonthlyIncome: editData
        ? editData?.application?.[0]?.newMonthlyIncome
        : 0,
      threeMonthBillAmount: editData
        ? editData?.application?.[0]?.threeMonthBillAmount
        : 0,
      id: "",
      bankName: editData ? editData?.application?.[0]?.bankName : "",
      branch: editData ? editData?.application?.[0]?.branch : "",
      HolderName: editData ? editData?.application?.[0]?.HolderName : "",
      IFSCCode: editData ? editData?.application?.[0]?.IFSCCode : "",
      AccountNo: editData ? editData?.application?.[0]?.AccountNo : "",
      formFillingDate: editData
        ? editData?.application[0]?.formFillingDate
        : "",
      applicationReceiveDate: editData
        ? editData?.application[0]?.applicationReceiveDate
        : "",
      // isMediclaim: "No",
      mediclaimAmmount: editData
        ? editData?.application?.[0]?.mediclaimAmmount
        : 0,
      isSahay: editData
        ? editData?.application[0]?.isSahay == true
          ? "Yes"
          : "No"
        : "No",
      trust: editData ? (editData?.trustRecords?.length ? "yes" : "no") : "no",
      SahayAmmount: editData ? editData?.application?.[0]?.SahayAmmount : "",
      rentSahayAmmount: editData
        ? editData?.application?.[0]?.rentSahayAmmount
        : 0,
      claimedAmmount: editData
        ? editData?.application?.[0]?.claimedAmmount
        : "",
      // trustName: "",
      // ammount: "",
      yearOfSahay: editData ? editData?.application?.[0]?.Year : "",
      bankMasterId: "",
      typeOfDisease:
        editData?.application[0]?.disease !== "NULL"
          ? editData?.application[0]?.disease
          : "",

      // documents: editData
      // ? editData?.document?.map((ele) => {
      //       return {
      //         id: ele?.id ? ele?.id : 0,
      //         file: ele?.isUpload ? ele?.document : "",
      //         filePath: ele?.isUpload ? ele?.filename : "",
      //         subSahayName: ele?.subSahayNme ? ele?.subSahayName : "",
      //         isUpload: ele?.isUpload ? ele?.isUpload : false,
      //         documentType: ele?.documentType ? ele?.documentType : "",
      //       };
      //     })
      // : [],

      documents: editData
        ? editData?.document?.map((ele) => {
            return {
              file: ele?.documents
                ?.filter((data) => data?.document !== "null")
                .filter((data) => data?.document !== "demo.png"),
              // filePath: ele?.isUpload ?  ele?.documents.map((data)=>data?.filename ): [],
              subSahayName: ele?.subSahayNme ? ele?.subSahayName : "",
              isUpload: ele?.isUpload ? ele?.isUpload : false,
              isRequired: ele?.isRequired ? ele?.isRequired : "",
              documentType: ele?.documentType ? ele?.documentType : "",
            };
          })
        : [],

      SaveSahay: editData ? editData?.application?.[0]?.SaveSahay : 0,
      passportPic: editData ? editData?.application?.[0]?.image : "",
      remark:
        editData?.application?.[0]?.remark !== "NULL"
          ? editData?.application?.[0]?.remark
          : "",
      isMediclaim: editData
        ? editData?.application[0]?.isMediclaim == true
          ? "Yes"
          : "No"
        : "No",
      mediclaimPremium: editData
        ? editData?.application[0]?.mediclaimPremium
        : 0,
      isSubmit: false,
      isDraft: editData ? editData?.application?.[0]?.SaveSahay : 0,
      // const filteredData = data.filter((_, index) => index !== 0);

      relationRecords: editData
        ? familyMembers &&
          familyMembers
            ?.filter?.((ele) => {
              return ele?.id != editData?.application[0]?.applicantId;
            })
            ?.map((ele) => {
              // if (
              //   ele?.name !== editData?.application[0].Name
              // ) {
              // }
              return {
                // id: ele?.id,
                // firstName: ele?.name,
                // lastName: "",
                // middleName: "",
                // age: ele?.age ? ele?.age : 0,
                // relation_id: +ele?.relationId,
                // workingType: ele?.workingType,
                // AnnualIncome: ele?.monthlyIncome ? ele?.monthlyIncome : 0,
                id: ele?.id,
                // firstName: ele?.name,
                firstName: `${ele?.firstName} ${ele?.middleName} ${ele?.lastName}`,
                lastName: "",
                middleName: "",
                age: ele?.age ? ele?.age : 0,
                relation_id: +ele?.relation_id,
                workingType: ele?.workingType,
                AnnualIncome: ele?.monthlyIncome ? ele?.monthlyIncome : "",
                newMonthlyIncome: ele?.newMonthlyIncome
                  ? ele?.newMonthlyIncome
                  : 0,
              };
            })
        : [
            {
              firstName: "",
              lastName: "",
              middleName: "",
              age: 0,
              relation_id: "",
              workingType: "",
              AnnualIncome: "",
              newMonthlyIncome: 0,
            },
          ],
      // relationRecords: [
      //   {
      //     firstName: "",
      //     lastName: "",
      //     middleName: "",
      //     age: "",
      //     relation_id: "",
      //     workingType: "",
      //     AnnualIncome: 0,
      //   },
      // ],

      dataArray: editData
        ? editData?.trustRecords?.map((ele) => {
            return {
              trustName: ele ? ele?.trustName : "",
              ammount: ele ? ele?.ammount : 0,
              id: ele ? ele?.id : "",
            };
          })
        : [
            {
              trustName: "",
              ammount: 0,
            },
          ],
    };
  }

  // useEffect(() => {
  //   let familyId = localStorage.getItem("familyId")
  //     ? localStorage.getItem("familyId")
  //     : 0;
  //   const data = {
  //     familyId: familyId,
  //     VastiPatra: getUserLoginDetails?.vastipatrak,
  //   };
  //   setSingleFamilyId(familyId);
  //   dispatch(getFamilyMemberById(data)).then((res) => {
  //     setFamilyMembers(res?.payload);
  //   });

  //   dispatch(listYearOfSahay()).then((data) => {
  //     if (data?.payload) {
  //       setListYearOfSahayData(data?.payload);
  //     } else {
  //       setListYearOfSahayData([]);
  //     }
  //   });
  // }, []);

  // useEffect(() => {
  //   if (applicantId) {
  //     dispatch(bankAccountsList(applicantId)).then((data) => {
  //       if (data?.payload) {
  //         setBankAccountsListData(data?.payload);
  //       } else {
  //         setBankAccountsListData([]);
  //       }
  //     });
  //   }
  // }, [applicantId]);

  const getSahayWiseDonner = (sahayTypeId) => {
    dispatch(getSahayWiseDonnerList(sahayTypeId)).then((res) => {
      setSahayWiseDonnerList(res?.payload);
    });
  };

  useEffect(() => {
    if (editData?.application?.[0]?.subSahayTypeId) {
      getSahayWiseDonner(editData?.application?.[0]?.subSahayTypeId);
    }
  }, [editData?.application?.[0]?.subSahayTypeId]);

  const handleBack = () => {
    navigate("/user/user-listing");
  };

  const SahayApplicationUpdate = async (data, id, documentData) => {
    try {
      const res = await DataService.post(
        `${Api.USER_SAHAYAPPLICATION_UPDATE}/${id}`,
        data,
      );

      if (res?.data?.status == 200 && saveVale === false) {
        dispatch(updateApplyForSahayDocuments(documentData)).then((ele) => {
          if (ele?.payload?.status == 200 || ele?.payload?.status == 201) {
            setTimeout(() => {
              handleCloseAftereSubmitModal();
            }, 20000);
            toast.success(res.data.message);
            navigate("/user/user-listing");
          } else {
            setTimeout(() => {
              handleCloseAftereSubmitModal();
            }, 20000);
          }
        });
      } else {
        setTimeout(() => {
          handleCloseAftereSubmitModal();
          navigate("/user/user-listing");
        }, 20000);
      }
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message);
      handleCloseAftereSubmitModal();
    }
  };

  //handle submit

  const handleFormSubmit = (values, { setFieldValue }) => {
    setFieldValue("isSubmit", true);
    const data = new FormData();
    handleOpenAfterSumitModal();
    let id = getUserLoginDetails?.mem_id;
    const currentDate = new Date().toISOString().split("T")[0];
    data.append("AadharNo", +values?.AadharNo);
    data.append("SahayType", +values?.SahayType);
    data.append("subSahayType", +values?.subSahayType);
    data.append("appliedBy", +id);
    data.append("applicantId", +values?.applicantId);
    data.append("beneficiaryName", +values?.beneficiaryName);
    data.append("threeMonthBillAmount", values?.threeMonthBillAmount);
    data.append("bankName", values?.bankName);
    data.append("branch", values?.branch);
    data.append("HolderName", values?.HolderName);
    data.append("IFSCCode", values?.IFSCCode);
    data.append("AccountNo", +values?.AccountNo);
    data.append("isMediclaim", values?.isMediclaim == "No" ? false : true);
    data.append("mediclaimAmmount", +values?.mediclaimAmmount);
    data.append("mediclaimPremium", +values?.mediclaimPremium);
    data.append("isSahay", values?.isSahay == "No" ? false : true);
    data.append("vastiPatrak", getUserLoginDetails?.vastipatrak ? 1 : 0);
    data.append("SahayAmmount", +values?.SahayAmmount);
    data.append("rentSahayAmmount", +values?.rentSahayAmmount);
    data.append("formFillingDate", currentDate);
    // data.append("formFillingDate", values?.formFillingDate);
    data.append("applicationReceiveDate", currentDate);
    // data.append("applicationReceiveDate", values?.applicationReceiveDate);
    // data.append(
    //   "claimedAmmount",
    //   getSingleSubSahay == 1014
    //     ? values?.mediclaimAmmount
    //     : values?.claimedAmmount
    // );
    data.append("claimedAmmount", values?.claimedAmmount);
    data.append("trustName", "TEST");
    data.append("yearOfSahay", values?.yearOfSahay);
    data.append(
      "monthlyIncome",
      values?.monthlyIncome ? values?.monthlyIncome : "",
    );
    data.append(
      "newMonthlyIncome",
      values?.newMonthlyIncome ? values?.newMonthlyIncome : 0,
    );
    data.append("name", values?.memberName);
    data.append("age", values?.age);
    data.append("workingType", values?.workingType);
    data.append("relation", values?.relation_id);
    data.append("remark", values?.remark ? values?.remark : "");
    data.append("patanMandalMember", values?.patanMandalMember);
    data.append("patanMemberMobile", values?.patanMemberMobile);
    data.append("SaveSahay", values?.isDraft);
    data.append("PANCardNo", values?.PANCardNo);
    {
      values?.patanReferenceName &&
        data.append("patanReferenceName", values?.patanReferenceName);
    }
    {
      values?.patanReferenceArea &&
        data.append("patanReferenceArea", values?.patanReferenceArea);
    }

    {
      values?.patanReferenceMohollo &&
        data.append("patanReferenceMohollo", values?.patanReferenceMohollo);
    }

    const documentData = new FormData();
    if (state?.editSahay == "edit") {
      const sahayId = editData?.application[0]?.sahayId;
      documentData.append("sahayId", sahayId);

      if (
        // editData?.application?.[0]?.sahayTypeId == values?.SahayType &&
        editData?.application?.[0]?.subSahayTypeId == values?.subSahayType
      ) {
        if (values?.documents?.length > 0) {
          let uploadIndex = 0;
          values?.documents?.forEach((ele) => {
            documentData.append(
              `documentsArray[${uploadIndex}][sequenceNo]`,
              uploadIndex + 1,
            );
            documentData.append(
              `documentsArray[${uploadIndex}][documentType]`,
              ele?.documentType,
            );

            if (Array.isArray(ele?.file) && ele.file.length > 0) {
              ele.file.forEach((file) => {
                documentData.append(
                  `documentsArray[${uploadIndex}][file]`,
                  file instanceof Blob ? file : file?.filename || "",
                );
              });
            } else {
              documentData.append(
                `documentsArray[${uploadIndex}][file]`,
                demoDocument,
              );
            }

            documentData.append(
              `documentsArray[${uploadIndex}][subSahayName]`,
              values?.subSahayName,
            );
            documentData.append(
              `documentsArray[${uploadIndex}][isUpload]`,
              ele?.isUpload ? 1 : 0,
            );
            documentData.append(
              `documentsArray[${uploadIndex}][isRequired]`,
              ele.isRequired ? 1 : 0,
            );

            uploadIndex++; // Increment uploadIndex here
          });
        }
      }

      if (values?.documents?.length > 0) {
        let oldIndex = 0;
        values?.documents?.forEach((ele) => {
          ele?.file?.forEach((data) => {
            if (!(data instanceof Blob) && ele?.isUpload == true) {
              documentData.append(
                `oldDocumentsArray[${oldIndex}][id]`,
                data?.id,
              );
              documentData.append(
                `oldDocumentsArray[${oldIndex}][newUpload]`,
                0,
              );
              documentData.append(
                `oldDocumentsArray[${oldIndex}][documentType]`,
                ele?.documentType,
              );

              documentData.append(
                `oldDocumentsArray[${oldIndex}][file]`,
                data?.document,
              );
              documentData.append(
                `oldDocumentsArray[${oldIndex}][subSahayName]`,
                values?.subSahayName || "",
              );
              documentData.append(
                `oldDocumentsArray[${oldIndex}][isUpload]`,
                ele?.isUpload ? 1 : 0,
              );
              documentData.append(
                `oldDocumentsArray[${oldIndex}][isRequired]`,
                ele?.isRequired ? 1 : 0,
              );
              oldIndex++;
            }
          });
        });
      }

      if (
        // editData?.application?.[0]?.sahayTypeId !== values?.SahayType &&
        editData?.application?.[0]?.subSahayTypeId !== values?.subSahayType
      ) {
        let uploadIndex = 0;
        values?.documents?.forEach((ele) => {
          documentData.append(
            `documentsArray[${uploadIndex}][sequenceNo]`,
            uploadIndex + 1,
          );
          documentData.append(
            `documentsArray[${uploadIndex}][documentType]`,
            ele?.documentType,
          );

          if (Array.isArray(ele?.file) && ele.file.length > 0) {
            ele.file.forEach((file) => {
              documentData.append(
                `documentsArray[${uploadIndex}][file]`,
                file instanceof Blob ? file : file?.filename || "",
              );
            });
          } else {
            documentData.append(
              `documentsArray[${uploadIndex}][file]`,
              demoDocument,
            );
          }

          documentData.append(
            `documentsArray[${uploadIndex}][subSahayName]`,
            values?.subSahayName,
          );
          documentData.append(
            `documentsArray[${uploadIndex}][isUpload]`,
            ele?.isUpload ? 1 : 0,
          );
          documentData.append(
            `documentsArray[${uploadIndex}][isRequired]`,
            ele?.isRequired ? 1 : 0,
          );

          uploadIndex++; // Increment uploadIndex here
        });
      }
    }
    {
      // bankAccountsListData &&
      //   bankAccountsListData?.length > 0 &&
      data.append("bankMasterId", +values?.bankMasterId);
    }
    if (values?.passportPic) {
      data.append("passportPic", values?.passportPic);
    }

    {
      sahayCondition == "yes" &&
        values?.dataArray?.forEach((ele, i) => {
          data.append(`trustRecords[${i}][trustName]`, ele?.trustName);
          data.append(`trustRecords[${i}][ammount]`, ele?.ammount);
        });
    }

    let newArr = [];
    values?.relationRecords?.filter(async (ele) => {
      await newArr.push({
        middleName: ele.middleName,
        age: ele.age,
        relation: ele.relation_id,
        workingType: ele.workingType,
        monthlyIncome: ele.monthlyIncome,
        newMonthlyIncome: ele.newMonthlyIncome || 0,
      });
    });

    data.append(`relationRecords[0][id]`, +values?.applicantId);
    data.append(`relationRecords[0][name]`, values?.memberName);
    data.append(`relationRecords[0][age]`, values?.age ? values?.age : 0);
    data.append(`relationRecords[0][workingType]`, values?.workingType);
    data.append(`relationRecords[0][relation]`, values?.relation_id);
    data.append(
      `relationRecords[0][monthlyIncome]`,
      values?.monthlyIncome ? values?.monthlyIncome : "",
    );
    data.append(
      `relationRecords[0][newMonthlyIncome]`,
      values?.newMonthlyIncome ? values?.newMonthlyIncome : 0,
    );

    values?.relationRecords?.forEach((ele, i) => {
      // if (state?.editSahay == "edit") {
      data.append(`relationRecords[${i + 1}][id]`, ele.id);
      // }
      data.append(`relationRecords[${i + 1}][name]`, ele.firstName);
      data.append(`relationRecords[${i + 1}][age]`, ele.age ? ele.age : 0);
      data.append(`relationRecords[${i + 1}][relation]`, ele.relation_id);
      data.append(
        `relationRecords[${i + 1}][monthlyIncome]`,
        ele.AnnualIncome ? ele.AnnualIncome : "",
      );
      data.append(`relationRecords[${i + 1}][workingType]`, ele.workingType);
      data.append(
        `relationRecords[${i + 1}][newMonthlyIncome]`,
        ele.newMonthlyIncome || 0,
      );
    });

      if (values?.policyHolders && values?.policyHolders?.length > 0) {
        values?.policyHolders?.forEach((ele, i) => {
          data.append(`policyHolders[${i}][fullName]`, ele.fullName);
          data.append(`policyHolders[${i}][relationship]`, ele.relationship);
          data.append(`policyHolders[${i}][age]`, ele.age);
          data.append(`policyHolders[${i}][sumInsured]`, ele.sumInsured);
          data.append(`policyHolders[${i}][totalPremium]`, ele.totalPremium);
        });
      }

      data.append(
        `insuranceCompanyName`,
        values?.insuranceCompanyName ? values?.insuranceCompanyName : "",
      );
      data.append(
        `branchNumber`,
        values?.branchNumber ? values?.branchNumber : "",
      );
      data.append(
        `policyNumber`,
        values?.policyNumber ? values?.policyNumber : "",
      );
      data.append(`place`, values?.place ? values?.place : "");
      data.append(
        `totalPremiumPaid`,
        values?.totalPremiumPaid ? values?.totalPremiumPaid : "",
      );
      data.append(
        `policyTermFrom`,
        values?.policyTermFrom ? values?.policyTermFrom : "",
      );
      data.append(
        `policyTermTo`,
        values?.policyTermTo ? values?.policyTermTo : "",
      );
      data.append(
        `lastYearAmount`,
        values?.lastYearAmount ? values?.lastYearAmount : "",
      );
      data.append(
        `lastYearUntilDate`,
        values?.lastYearUntilDate ? values?.lastYearUntilDate : "",
      );
      data.append(
        `policyTypeSelect`,
        values?.policyTypeSelect ? values?.policyTypeSelect : "",
      );
      data.append(
        `claimReceived`,
        values?.claimReceived ? values?.claimReceived : "",
      );
      data.append(
        `sbiPolicyTaken`,
        values?.sbiPolicyTaken ? values?.sbiPolicyTaken : "",
      );
      data.append(
        `policyReason`,
        values?.policyReason ? values?.policyReason : "",
      );
      data.append(
        `policyCategory`,
        values?.policyCategory ? values?.policyCategory : "",
      );
    

   
      // medicine distribution records Medical Bills
      if (values?.medicalBills && values?.medicalBills?.length > 0) {
        values?.medicalBills?.forEach((ele, i) => {
          data.append(`medicalBills[${i}][storeName]`, ele.storeName);
          data.append(`medicalBills[${i}][date]`, ele.date);
          data.append(`medicalBills[${i}][amount]`, ele.amount);
        });
      }

      data.append(
        `receivedAidFromOthers`,
        values?.receivedAidFromOthers ? values?.receivedAidFromOthers : "",
      );
      data.append(
        `assistanceOrg1Name`,
        values?.assistanceOrg1Name ? values?.assistanceOrg1Name : "",
      );
      data.append(
        `assistanceOrg1Amount`,
        values?.assistanceOrg1Amount ? values?.assistanceOrg1Amount : "",
      );
      data.append(
        `assistanceOrg2Name`,
        values?.assistanceOrg2Name ? values?.assistanceOrg2Name : "",
      );
      data.append(
        `assistanceOrg2Amount`,
        values?.assistanceOrg2Amount ? values?.assistanceOrg2Amount : "",
      );
      data.append(
        `directMedicineSchemeJoined`,
        values?.directMedicineSchemeJoined
          ? values?.directMedicineSchemeJoined
          : "",
      );
      data.append(
        `directMedicineSchemeReason`,
        values?.directMedicineSchemeReason
          ? values?.directMedicineSchemeReason
          : "",
      );
    

    
      if (
        values?.familyMembersDetails &&
        values.familyMembersDetails.length > 0
      ) {
        values.familyMembersDetails.forEach((member, i) => {
          data.append(
            `familyMembersDetails[${i}][fullName]`,
            member.fullName || "",
          );
          data.append(
            `familyMembersDetails[${i}][relation]`,
            member.relation || "",
          );
          data.append(`familyMembersDetails[${i}][age]`, member.age || 0);
          data.append(
            `familyMembersDetails[${i}][currentActivity]`,
            member.currentActivity || "",
          );
          data.append(
            `familyMembersDetails[${i}][monthlyIncome]`,
            member.monthlyIncome || 0,
          );
        });
      }

      data.append("totalFamilyMembers", values?.totalFamilyMembers || "");
      data.append("earningMembers", values?.earningMembers || "");
      data.append("mainAilmentDetails", values?.mainAilmentDetails || "");
      data.append("otherAilmentsDetails", values?.otherAilmentsDetails || "");
      data.append("illnessDuration", values?.illnessDuration || "");
      data.append("familyDoctorName", values?.familyDoctorName || "");
      data.append("familyDoctorMobile", values?.familyDoctorMobile || "");
      data.append("operationPerformed", values?.operationPerformed || "");
      data.append("doctorConsultantName", values?.doctorConsultantName || "");
      data.append(
        "hospitalNursingHomeName",
        values?.hospitalNursingHomeName || "",
      );

      // Medication Expenses
      if (values?.medicationExpenses && values.medicationExpenses.length > 0) {
        values.medicationExpenses.forEach((expense, i) => {
          data.append(
            `medicationExpenses[${i}][description]`,
            expense.description || "",
          );
          data.append(`medicationExpenses[${i}][amount]`, expense.amount || 0);
        });
      }

      // Hospital Expenses
      if (values?.hospitalExpenses && values.hospitalExpenses.length > 0) {
        values.hospitalExpenses.forEach((expense, i) => {
          data.append(
            `hospitalExpenses[${i}][description]`,
            expense.description || "",
          );
          data.append(`hospitalExpenses[${i}][amount]`, expense.amount || 0);
        });
      }

      // Hospital Details
      data.append("hospitalClass", values?.hospitalClass || "");
      data.append("hospitalDays", values?.hospitalDays || "");
      data.append("dailyCharge", values?.dailyCharge || "");
      data.append("icuDays", values?.icuDays || "");
      data.append("icuDailyCharge", values?.icuDailyCharge || "");
      data.append("treatmentReason", values?.treatmentReason || "");

      // Mediclaim Details
      data.append("mediclaimPolicyTaken", values?.mediclaimPolicyTaken || "");
      data.append("mediclaimPolicyAmount", values?.mediclaimPolicyAmount || "");
      data.append(
        "associationMediclaimTaken",
        values?.associationMediclaimTaken || "",
      );
      data.append(
        "associationMediclaimAmount",
        values?.associationMediclaimAmount || "",
      );
      data.append(
        "mediclaimNotTakenReason",
        values?.mediclaimNotTakenReason || "",
      );
      data.append(
        "mediclaimPremiumAssistance",
        values?.mediclaimPremiumAssistance || "",
      );
      data.append(
        "mediclaimPremiumAmount",
        values?.mediclaimPremiumAmount || "",
      );
      data.append(
        "receivedMedicineAssistanceLast12Months",
        values?.receivedMedicineAssistanceLast12Months || "",
      );
      data.append(
        "medicineAssistanceAmount",
        values?.medicineAssistanceAmount || "",
      );

      // Known Person Details
      data.append("knownPersonFullName", values?.knownPersonFullName || "");
      data.append("knownPersonResidence", values?.knownPersonResidence || "");
      data.append(
        "knownPersonNeighborhood",
        values?.knownPersonNeighborhood || "",
      );
      data.append("knownPersonHomePhone", values?.knownPersonHomePhone || "");
      data.append("knownPersonMobile", values?.knownPersonMobile || "");

      // Medicine Bills Details
      if (
        values?.medicineBillsDetails &&
        values.medicineBillsDetails.length > 0
      ) {
        values.medicineBillsDetails.forEach((bill, i) => {
          data.append(`medicineBillsDetails[${i}][date]`, bill.date || "");
          data.append(`medicineBillsDetails[${i}][amount]`, bill.amount || 0);
          data.append(
            `medicineBillsDetails[${i}][medicalStoreName]`,
            bill.medicalStoreName || "",
          );
        });
      }

      // Diagnosis Bills Details
      if (
        values?.diagnosisBillsDetails &&
        values.diagnosisBillsDetails.length > 0
      ) {
        values.diagnosisBillsDetails.forEach((bill, i) => {
          data.append(`diagnosisBillsDetails[${i}][date]`, bill.date || "");
          data.append(
            `diagnosisBillsDetails[${i}][laboratoryName]`,
            bill.laboratoryName || "",
          );
          data.append(`diagnosisBillsDetails[${i}][amount]`, bill.amount || 0);
        });
      }

      // Hospital Bills Details
      if (
        values?.hospitalBillsDetails &&
        values.hospitalBillsDetails.length > 0
      ) {
        values.hospitalBillsDetails.forEach((bill, i) => {
          data.append(`hospitalBillsDetails[${i}][date]`, bill.date || "");
          data.append(
            `hospitalBillsDetails[${i}][details]`,
            bill.details || "",
          );
          data.append(`hospitalBillsDetails[${i}][amount]`, bill.amount || 0);
        });
      }

      // Other Expenses Details
      if (
        values?.otherExpensesDetails &&
        values.otherExpensesDetails.length > 0
      ) {
        values.otherExpensesDetails.forEach((expense, i) => {
          data.append(`otherExpensesDetails[${i}][date]`, expense.date || "");
          data.append(
            `otherExpensesDetails[${i}][details]`,
            expense.details || "",
          );
          data.append(
            `otherExpensesDetails[${i}][amount]`,
            expense.amount || 0,
          );
        });
      }

      // External Assistance
      data.append(
        "receivedExternalAssistance",
        values?.receivedExternalAssistance || "",
      );
      if (
        values?.externalAssistanceDetails &&
        values.externalAssistanceDetails.length > 0
      ) {
        values.externalAssistanceDetails.forEach((assistance, i) => {
          data.append(
            `externalAssistanceDetails[${i}][organizationName]`,
            assistance.organizationName || "",
          );
          data.append(
            `externalAssistanceDetails[${i}][amount]`,
            assistance.amount || 0,
          );
        });
      }

    SahayApplicationUpdate(
      data,
      editData?.application?.[0]?.sahayId,
      documentData,
    );
  };

  //Document Uploads Sub sahay wise
  const uploadDocuments = (id, setFieldValue) => {
    const subSahayFilter = sahaySubTypeList?.filter((ele) => {
      return ele?.Id == id;
    });
    const filterData = subSahayFilter?.filter((ele) => {
      const subSahayMatch = sahayDocumentArray?.filter((subSahay) => {
        return subSahay?.subSahayName === ele?.SahayName;
      });
      if (
        subSahayMatch?.length > 0 &&
        subSahayMatch?.[0]?.documentData?.length > 0
      ) {
        setFieldValue("documents", subSahayMatch?.[0]?.documentData);
        setFieldValue("subSahayName", subSahayMatch?.[0]?.subSahayName);
      } else {
        setFieldValue("documents", []);
      }
    });
  };

  useEffect(() => {
    const file = {
      name: "demo.png",
      lastModified: 1701162357663,
      lastModifiedDate: new Date(
        "Tue Nov 28 2023 14:35:57 GMT+0530 (India Standard Time)",
      ),
      webkitRelativePath: "",
      size: 8595,
      type: "image/png",
    };
    const fileData = new File([new Blob([file])], file.name, {
      type: file.type,
    });
    setDemoDocument(fileData);
  }, []);

  const openSecureImageWithAuth = async (docImageData) => {
    const token = JSON.parse(localStorage.getItem("token"));

    try {
      const res = await dispatch(getCheckAuthenticationDocument(docImageData));

      const signedUrl = res?.payload?.url;

      if (signedUrl) {
        const imageRes = await axios.get(signedUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });
        const blobUrl = URL.createObjectURL(imageRes.data);
        const ComponentData = "editsahay";
        navigate("/image-view", {
          state: {
            blobUrl,
            docImageData,
            state,
            ComponentData,
          },
        });
      } else {
        toast.error("Signed URL not received.");
      }
    } catch (err) {
      toast.error("Failed to open image.");
    }
  };

  const getSahayApplicatOldBankDetailData = async (mem_id, setFieldValue) => {
    try {
      if (mem_id) {
        const res = await getSahayApplicatOldBankDetail({ mem_id });
        const memberData = res.data[0] ?? {};
        setFieldValue("AadharNo", memberData?.AadharNo ?? "");
        setFieldValue("bankName", memberData?.bankName ?? "");
        setFieldValue("branch", memberData?.branch ?? "");
        setFieldValue("HolderName", memberData?.HolderName ?? "");
        setFieldValue("IFSCCode", memberData?.IFSCCode ?? "");
        setFieldValue("AccountNo", memberData?.AccountNo ?? "");
        setFieldValue("passportPic", memberData?.passportPic ?? "");
        // setSelectedImage(memberData?.passportPic ?? "")
      }
    } catch (error) {
      console.log(error, "error");
    }
  };

  return (
    <>
      <div>
        {" "}
        {/* {!loading ? ( */}
        <Index.Box className="apply-sahay-main">
          <Sidebar />
          {!loading ? (
            <Index.Box className="head-content">
              <Index.Box className="user-right">
                <Index.Box className="bottom-user-right">
                  <Index.Box className="user-apply-content">
                    <PagesIndex.Formik
                      enableReinitialize
                      onSubmit={handleFormSubmit}
                      initialValues={initialValues}
                      validationSchema={
                        saveVale === true
                          ? validationSchemaSave
                          : validationSchemaApplyForSahayUser
                      }

                      ///////////////////////////////
                      // validationSchema={
                      //   saveVale === true
                      //     ? validationSchemaSave
                      //     : bankAccountsListData &&
                      //       bankAccountsListData?.length == 0
                      //     ? validationSchemaApplyForSahayUser
                      //     : validationSchemaApplyForSahayBankMemberUser
                      // }
                    >
                      {({
                        values,
                        handleChange,
                        handleSubmit,
                        touched,
                        setFieldValue,
                        handleBlur,
                        errors,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <Index.Box className="main-in-row">
                            {listingData?.SaveSahay === 0 && (
                              <Index.Box className="user-basic user-heading">
                                <Index.Typography
                                  // component="h4"
                                  className="head-apply-show-message"
                                >
                                  Your application is NOT SUBMITTED, its saved
                                  as DRAFT (તમારી અરજી સબમિટ કરવામાં આવી નથી,
                                  તેને ડ્રાફ્ટ ગણવામાં આવે છે)
                                </Index.Typography>
                              </Index.Box>
                            )}
                            <Index.Box className="user-basic user-heading">
                              <Index.Typography
                                component="h1"
                                className="head-apply"
                              >
                                Edit sahay (સહાય સંપાદિત કરો)
                              </Index.Typography>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="main-in-row">
                            <Index.Box
                              className="user-basic"
                              sx={{ display: "flex" }}
                            >
                              <Index.Typography
                                component="p"
                                className="head-apply"
                              >
                                Basic Details (મૂળભૂત વિગતો)
                              </Index.Typography>
                              <Index.Typography
                                component="h1"
                                className="head-apply"
                              >
                                ({" "}
                                {getUserLoginDetails?.vastipatrak
                                  ? "Member"
                                  : "Non Member"}{" "}
                                )
                              </Index.Typography>
                            </Index.Box>
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      FamilyId (કૌટુંબિક આઈડી)
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      value={singlaFamilyId && singlaFamilyId}
                                    />
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Mohalla Name (મોહલ્લા નામ)
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      value={
                                        singlaMohallaName
                                          ? singlaMohallaName.replace(/"/g, "")
                                          : ""
                                      }
                                    />
                                  </Index.Box>{" "}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Aadhar Card Number (આધાર કાર્ડ નંબર)
                                    </Index.Typography>
                                    <Index.TextField
                                      type="string"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="AadharNo"
                                      value={values?.AadharNo}
                                      onChange={(e) => {
                                        const inputValue =
                                          e.target.value.replace(/\D/g, "");
                                        setFieldValue(
                                          "AadharNo",
                                          inputValue.slice(0, 12),
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.AadharNo && touched?.AadharNo && (
                                    <p className="error-text">
                                      {errors?.AadharNo}
                                    </p>
                                  )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Sahay Type (સહાય પ્રકાર)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        value={values?.SahayType}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "SahayType",
                                            e.target.value,
                                          );
                                          setFieldValue("subSahayType", "");
                                          getSahaySubTypeData(e.target.value);
                                        }}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {sahayTypeList?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.Id}
                                            value={ele?.Id}
                                          >
                                            {ele?.Sahay_category}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.SahayType &&
                                      touched?.SahayType && (
                                        <p className="error-text">
                                          {errors?.SahayType}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Sub Sahay Type (સબ સહાય પ્રકાર)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        value={values?.subSahayType}
                                        onChange={(e) => {
                                            const newSubSahayId = e.target.value;
  const newSubSahayName = sahaySubTypeList?.find(
    (data) => +data?.Id == +newSubSahayId,
  )?.SahayName;

                                          getSahayWiseDonner(e.target.value);
                                          setGetSingleSubSahay(e.target.value);
                                          setFieldValue(
                                            "subSahayType",
                                            e.target.value,
                                          );
                                          setFieldValue("documents", []);
                                          uploadDocuments(
                                            e.target.value,
                                            setFieldValue,
                                          );
                                          setFieldValue(
                                            "subSahayName",
                                            sahaySubTypeList?.find(
                                              (data) =>
                                                +data?.Id == +e.target.value,
                                            )?.SahayName,
                                          );
                                          setFieldValue(
                                            "isLoan",
                                            sahaySubTypeList?.find(
                                              (data) =>
                                                +data?.Id == +e.target.value,
                                            )?.isLoan,
                                          );
                                            
  const originalSubSahayId = editData?.application?.[0]?.subSahayTypeId;
  const isSwitchingBackToOriginal =  +newSubSahayId === +originalSubSahayId;

  if (isSwitchingBackToOriginal) {
    // Restore original data from editData

    // Mediclaim Premium Sahay
    if (newSubSahayName?.toLowerCase() === "mediclaim premium sahay") {
      setFieldValue(
        "policyHolders",
        editData?.policyHolders?.length > 0
          ? editData.policyHolders
          : [
              {
                fullName: "",
                relationship: "Applicant",
                age: "",
                sumInsured: "",
                totalPremium: "",
              },
            ],
      );
      setFieldValue(
        "insuranceCompanyName",
        editData?.application[0]?.insuranceCompanyName || "",
      );
      setFieldValue(
        "branchNumber",
        editData?.application[0]?.branchNumber || "",
      );
      setFieldValue(
        "policyNumber",
        editData?.application[0]?.policyNumber || "",
      );
      setFieldValue(
        "place",
        editData?.application[0]?.place || "",
      );
      setFieldValue(
        "totalPremiumPaid",
        editData?.application[0]?.totalPremiumPaid || "",
      );
      setFieldValue(
        "policyTermFrom",
        editData?.application[0]?.policyTermFrom || "",
      );
      setFieldValue(
        "policyTermTo",
        editData?.application[0]?.policyTermTo || "",
      );
      setFieldValue(
        "lastYearAmount",
        editData?.application[0]?.lastYearAmount || "",
      );
      setFieldValue(
        "lastYearUntilDate",
        editData?.application[0]?.lastYearUntilDate || "",
      );
      setFieldValue(
        "policyTypeSelect",
        editData?.application[0]?.policyTypeSelect || "",
      );
      setFieldValue(
        "claimReceived",
        editData?.application[0]?.claimReceived || "",
      );
      setFieldValue(
        "sbiPolicyTaken",
        editData?.application[0]?.sbiPolicyTaken || "",
      );
      setFieldValue(
        "policyReason",
        editData?.application[0]?.policyReason || "",
      );
      setFieldValue(
        "policyCategory",
        editData?.application[0]?.policyCategory || "",
      );
    }

    // Medicine Sahay
    else if (newSubSahayName?.toLowerCase() === "medicine sahay") {
      setFieldValue(
        "medicalBills",
        editData?.medicalBills?.length > 0
          ? editData.medicalBills.map((ele) => ({
              storeName: ele?.storeName || "",
              date: ele?.date || "",
              amount: ele?.amount || 0,
            }))
          : [
              {
                storeName: "",
                date: "",
                amount: 0,
              },
            ],
      );
      setFieldValue(
        "receivedAidFromOthers",
        editData?.application[0]?.receivedAidFromOthers || "no",
      );
      setFieldValue(
        "assistanceOrg1Name",
        editData?.application[0]?.assistanceOrg1Name || "",
      );
      setFieldValue(
        "assistanceOrg1Amount",
        editData?.application[0]?.assistanceOrg1Amount || 0,
      );
      setFieldValue(
        "assistanceOrg2Name",
        editData?.application[0]?.assistanceOrg2Name || "",
      );
      setFieldValue(
        "assistanceOrg2Amount",
        editData?.application[0]?.assistanceOrg2Amount || 0,
      );
      setFieldValue(
        "directMedicineSchemeJoined",
        editData?.application[0]?.directMedicineSchemeJoined || "no",
      );
      setFieldValue(
        "directMedicineSchemeReason",
        editData?.application[0]?.directMedicineSchemeReason || "",
      );
    }

    // Medical Sahay
    else if (newSubSahayName?.toLowerCase() === "medical sahay") {
      setFieldValue(
        "familyMembersDetails",
        editData?.medicalSahay?.familyMembersDetails?.length > 0
          ? editData.medicalSahay.familyMembersDetails.map((member) => ({
              fullName: member?.fullName || "",
              relation: member?.relation || "",
              age: member?.age || "",
              currentActivity: member?.currentActivity || "",
              monthlyIncome: member?.monthlyIncome || "",
            }))
          : [
              {
                fullName: "",
                relation: "",
                age: "",
                currentActivity: "",
                monthlyIncome: "",
              },
            ],
      );
      setFieldValue(
        "totalFamilyMembers",
        editData?.medicalSahay?.totalFamilyMembers || "",
      );
      setFieldValue(
        "earningMembers",
        editData?.medicalSahay?.earningMembers || "",
      );
      setFieldValue(
        "mainAilmentDetails",
        editData?.medicalSahay?.mainAilmentDetails || "",
      );
      setFieldValue(
        "otherAilmentsDetails",
        editData?.medicalSahay?.otherAilmentsDetails || "",
      );
      setFieldValue(
        "illnessDuration",
        editData?.medicalSahay?.illnessDuration || "",
      );
      setFieldValue(
        "familyDoctorName",
        editData?.medicalSahay?.familyDoctorName || "",
      );
      setFieldValue(
        "familyDoctorMobile",
        editData?.medicalSahay?.familyDoctorMobile || "",
      );
      setFieldValue(
        "operationPerformed",
        editData?.medicalSahay?.operationPerformed || "",
      );
      setFieldValue(
        "doctorConsultantName",
        editData?.medicalSahay?.doctorConsultantName || "",
      );
      setFieldValue(
        "hospitalNursingHomeName",
        editData?.medicalSahay?.hospitalNursingHomeName || "",
      );
      setFieldValue(
        "medicationExpenses",
        editData?.medicalSahay?.medicationExpenses?.length > 0
          ? editData.medicalSahay.medicationExpenses.map((expense) => ({
              description: expense?.description || "",
              amount: expense?.amount || "",
            }))
          : [
              { description: "Medicine cost (as per bill)", amount: "" },
              { description: "Consultant fee", amount: "" },
              { description: "Report cost", amount: "" },
              { description: "Other expenses (with details)", amount: "" },
            ],
      );
      setFieldValue(
        "hospitalExpenses",
        editData?.medicalSahay?.hospitalExpenses?.length > 0
          ? editData.medicalSahay.hospitalExpenses.map((expense) => ({
              description: expense?.description || "",
              amount: expense?.amount || "",
            }))
          : [
              { description: "Doctor charges", amount: "" },
              { description: "Hospital bill", amount: "" },
              { description: "Equipment bill", amount: "" },
            ],
      );
      setFieldValue(
        "hospitalClass",
        editData?.medicalSahay?.hospitalClass || "",
      );
      setFieldValue(
        "hospitalDays",
        editData?.medicalSahay?.hospitalDays || "",
      );
      setFieldValue(
        "dailyCharge",
        editData?.medicalSahay?.dailyCharge || "",
      );
      setFieldValue(
        "icuDays",
        editData?.medicalSahay?.icuDays || "",
      );
      setFieldValue(
        "icuDailyCharge",
        editData?.medicalSahay?.icuDailyCharge || "",
      );
      setFieldValue(
        "treatmentReason",
        editData?.medicalSahay?.treatmentReason || "",
      );
      setFieldValue(
        "mediclaimPolicyTaken",
        editData?.medicalSahay?.mediclaimPolicyTaken || "no",
      );
      setFieldValue(
        "mediclaimPolicyAmount",
        editData?.medicalSahay?.mediclaimPolicyAmount || "",
      );
      setFieldValue(
        "associationMediclaimTaken",
        editData?.medicalSahay?.associationMediclaimTaken || "no",
      );
      setFieldValue(
        "associationMediclaimAmount",
        editData?.medicalSahay?.associationMediclaimAmount || "",
      );
      setFieldValue(
        "mediclaimNotTakenReason",
        editData?.medicalSahay?.mediclaimNotTakenReason || "",
      );
      setFieldValue(
        "mediclaimPremiumAssistance",
        editData?.medicalSahay?.mediclaimPremiumAssistance || "no",
      );
      setFieldValue(
        "mediclaimPremiumAmount",
        editData?.medicalSahay?.mediclaimPremiumAmount || "",
      );
      setFieldValue(
        "receivedMedicineAssistanceLast12Months",
        editData?.medicalSahay?.receivedMedicineAssistanceLast12Months || "no",
      );
      setFieldValue(
        "medicineAssistanceAmount",
        editData?.medicalSahay?.medicineAssistanceAmount || "",
      );
      setFieldValue(
        "knownPersonFullName",
        editData?.medicalSahay?.knownPersonFullName || "",
      );
      setFieldValue(
        "knownPersonResidence",
        editData?.medicalSahay?.knownPersonResidence || "",
      );
      setFieldValue(
        "knownPersonNeighborhood",
        editData?.medicalSahay?.knownPersonNeighborhood || "",
      );
      setFieldValue(
        "knownPersonHomePhone",
        editData?.medicalSahay?.knownPersonHomePhone || "",
      );
      setFieldValue(
        "knownPersonMobile",
        editData?.medicalSahay?.knownPersonMobile || "",
      );
      setFieldValue(
        "medicineBillsDetails",
        editData?.medicalSahay?.medicineBillsDetails?.length > 0
          ? editData.medicalSahay.medicineBillsDetails.map((bill) => ({
              date: bill?.date || "",
              amount: bill?.amount || "",
              medicalStoreName: bill?.medicalStoreName || "",
            }))
          : [{ date: "", amount: "", medicalStoreName: "" }],
      );
      setFieldValue(
        "diagnosisBillsDetails",
        editData?.medicalSahay?.diagnosisBillsDetails?.length > 0
          ? editData.medicalSahay.diagnosisBillsDetails.map((bill) => ({
              date: bill?.date || "",
              laboratoryName: bill?.laboratoryName || "",
              amount: bill?.amount || "",
            }))
          : [{ date: "", laboratoryName: "", amount: "" }],
      );
      setFieldValue(
        "hospitalBillsDetails",
        editData?.medicalSahay?.hospitalBillsDetails?.length > 0
          ? editData.medicalSahay.hospitalBillsDetails.map((bill) => ({
              date: bill?.date || "",
              details: bill?.details || "",
              amount: bill?.amount || "",
            }))
          : [{ date: "", details: "", amount: "" }],
      );
      setFieldValue(
        "otherExpensesDetails",
        editData?.medicalSahay?.otherExpensesDetails?.length > 0
          ? editData.medicalSahay.otherExpensesDetails.map((expense) => ({
              date: expense?.date || "",
              details: expense?.details || "",
              amount: expense?.amount || "",
            }))
          : [{ date: "", details: "", amount: "" }],
      );
      setFieldValue(
        "receivedExternalAssistance",
        editData?.medicalSahay?.receivedExternalAssistance || "no",
      );
      setFieldValue(
        "externalAssistanceDetails",
        editData?.medicalSahay?.externalAssistanceDetails?.length > 0
          ? editData.medicalSahay.externalAssistanceDetails.map((assistance) => ({
              organizationName: assistance?.organizationName || "",
              amount: assistance?.amount || "",
            }))
          : [{ organizationName: "", amount: "" }],
      );
    }
  } else {
    // Clear fields when switching to different sub-sahay (existing logic)

    if (newSubSahayName?.toLowerCase() !== "mediclaim premium sahay") {
      setFieldValue("policyHolders", [
        {
          fullName: "",
          relationship: "Applicant",
          age: "",
          sumInsured: "",
          totalPremium: "",
        },
      ]);
      setFieldValue("insuranceCompanyName", "");
      setFieldValue("branchNumber", "");
      setFieldValue("policyNumber", "");
      setFieldValue("place", "");
      setFieldValue("totalPremiumPaid", "");
      setFieldValue("policyTermFrom", "");
      setFieldValue("policyTermTo", "");
      setFieldValue("lastYearAmount", "");
      setFieldValue("lastYearUntilDate", "");
      setFieldValue("policyTypeSelect", "");
      setFieldValue("claimReceived", "");
      setFieldValue("sbiPolicyTaken", "");
      setFieldValue("policyReason", "");
      setFieldValue("policyCategory", "");
    }

    if (newSubSahayName?.toLowerCase() !== "medicine sahay") {
      setFieldValue("medicalBills", [
        {
          storeName: "",
          date: "",
          amount: 0,
        },
      ]);
      setFieldValue("receivedAidFromOthers", "");
      setFieldValue("assistanceOrg1Name", "");
      setFieldValue("assistanceOrg1Amount", "");
      setFieldValue("assistanceOrg2Name", "");
      setFieldValue("assistanceOrg2Amount", "");
      setFieldValue("directMedicineSchemeJoined", "");
      setFieldValue("directMedicineSchemeReason", "");
    }

    if (newSubSahayName?.toLowerCase() !== "medical sahay") {
      setFieldValue("familyMembersDetails", [
        {
          fullName: "",
          relation: "",
          age: "",
          currentActivity: "",
          monthlyIncome: "",
        },
      ]);
      setFieldValue("totalFamilyMembers", "");
      setFieldValue("earningMembers", "");
      setFieldValue("mainAilmentDetails", "");
      setFieldValue("otherAilmentsDetails", "");
      setFieldValue("illnessDuration", "");
      setFieldValue("familyDoctorName", "");
      setFieldValue("familyDoctorMobile", "");
      setFieldValue("operationPerformed", "");
      setFieldValue("doctorConsultantName", "");
      setFieldValue("hospitalNursingHomeName", "");
      setFieldValue("medicationExpenses", [
        { description: "Medicine cost (as per bill)", amount: "" },
        { description: "Consultant fee", amount: "" },
        { description: "Report cost", amount: "" },
        { description: "Other expenses (with details)", amount: "" },
      ]);
      setFieldValue("hospitalExpenses", [
        { description: "Doctor charges", amount: "" },
        { description: "Hospital bill", amount: "" },
        { description: "Equipment bill", amount: "" },
      ]);
      setFieldValue("hospitalClass", "");
      setFieldValue("hospitalDays", "");
      setFieldValue("dailyCharge", "");
      setFieldValue("icuDays", "");
      setFieldValue("icuDailyCharge", "");
      setFieldValue("treatmentReason", "");
      setFieldValue("mediclaimPolicyTaken", "no");
      setFieldValue("mediclaimPolicyAmount", "");
      setFieldValue("associationMediclaimTaken", "no");
      setFieldValue("associationMediclaimAmount", "");
      setFieldValue("mediclaimNotTakenReason", "");
      setFieldValue("mediclaimPremiumAssistance", "no");
      setFieldValue("mediclaimPremiumAmount", "");
      setFieldValue("receivedMedicineAssistanceLast12Months", "no");
      setFieldValue("medicineAssistanceAmount", "");
      setFieldValue("knownPersonFullName", "");
      setFieldValue("knownPersonResidence", "");
      setFieldValue("knownPersonNeighborhood", "");
      setFieldValue("knownPersonHomePhone", "");
      setFieldValue("knownPersonMobile", "");
      setFieldValue("medicineBillsDetails", [{ date: "", amount: "", medicalStoreName: "" }]);
      setFieldValue("diagnosisBillsDetails", [{ date: "", laboratoryName: "", amount: "" }]);
      setFieldValue("hospitalBillsDetails", [{ date: "", details: "", amount: "" }]);
      setFieldValue("otherExpensesDetails", [{ date: "", details: "", amount: "" }]);
      setFieldValue("receivedExternalAssistance", "no");
      setFieldValue("externalAssistanceDetails", [{ organizationName: "", amount: "" }]);
    }

    // Call setMemberDetails ONLY when not switching back to original
    setMemberDeatils(values?.applicantId, setFieldValue, newSubSahayName);
  }
                                        }}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {sahaySubTypeList?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.Id}
                                            value={ele?.Id}
                                          >
                                            {ele?.SahayName}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.subSahayType &&
                                      touched?.subSahayType && (
                                        <p className="error-text">
                                          {errors?.subSahayType}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>

                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Year Of Sahay (સહાયનું વર્ષ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      type="string"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="yearOfSahay"
                                      value={values?.yearOfSahay}
                                    />
                                  </Index.Box>
                                  {errors?.yearOfSahay &&
                                    touched?.yearOfSahay && (
                                      <p className="error-text">
                                        {errors?.yearOfSahay}
                                      </p>
                                    )}
                                </Index.Grid>

                                {Array.isArray(sahayWiseDonnerList) &&
                                  sahayWiseDonnerList?.length > 0 && (
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={12}
                                      md={12}
                                      lg={12}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Donner Name (દાતા નામ)
                                        </Index.Typography>
                                        <Index.Box className="donner-name">
                                          <Index.Typography>
                                            {sahayWiseDonnerList
                                              ?.map((donner) =>
                                                donner.DonnerName.trim(),
                                              )
                                              .join(", ")}
                                          </Index.Typography>
                                        </Index.Box>
                                      </Index.Box>
                                      {errors?.donnerNames &&
                                        touched.donnerNames && (
                                          <p className="error-text">
                                            {errors?.donnerNames}
                                          </p>
                                        )}
                                    </Index.Grid>
                                  )}

                                {getSingleSubSahay == 1017 ? (
                                  <Index.Grid item xs={12} sm={6} md={4} lg={3}>
                                    <Index.Typography
                                      component="p"
                                      sx={{ fontSize: "12px" }}
                                      // className="head-apply"
                                    >
                                      Type Of Disease (રોગનો પ્રકાર)
                                    </Index.Typography>
                                    <Index.Box className="lable-input-grp">
                                      <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="typeOfDisease"
                                        value={values?.typeOfDisease}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                    </Index.Box>
                                    {/* {errors?.IFSCCode && (
                                  <p className="error-text">
                                    {errors?.IFSCCode}
                                  </p>
                                )} */}
                                  </Index.Grid>
                                ) : null}

                                {sahaySubTypeList?.find(
                                  (data) => +data?.Id == +values?.subSahayType,
                                )?.isLoan == true ? (
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        PAN Card No. (પાન કાર્ડ નં.)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="PANCardNo"
                                          value={values?.PANCardNo}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                    <Index.FormHelperText error>
                                      {touched?.PANCardNo && errors?.PANCardNo}
                                    </Index.FormHelperText>
                                  </Index.Grid>
                                ) : (
                                  <></>
                                )}

                                {getSingleSubSahay == 1010 && (
                                  <Index.Grid item xs={12} sm={6} md={4} lg={3}>
                                    {/* {getSingleSubSahay == 1010 ? ( */}
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Rent Amount For Rent Sahay (સહાય માટે
                                        ભાડાની રકમ)
                                      </Index.Typography>
                                      <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="rentSahayAmmount"
                                        value={values?.rentSahayAmmount}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      />
                                    </Index.Box>
                                  </Index.Grid>
                                )}

                                {/* <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Typography
                                    component="p"
                                    className="in-label"
                                  >
                                    Application Received Date*
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border date-input-box">
                                    <Index.LocalizationProvider
                                      dateAdapter={Index.AdapterDayjs}
                                      sx={{ position: "absolute" }}
                                    >
                                      <Index.DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <Index.DatePicker
                                          name="applicationReceiveDate"
                                          onChange={(value) => {
                                            setFieldValue(
                                              "applicationReceiveDate",
                                              moment(value.$d).format(
                                                "YYYY-MM-DD"
                                              )
                                            );
                                          }}
                                          value={dayjs(
                                            values?.applicationReceiveDate
                                          )}
                                          format="YYYY-MM-DD"
                                          sx={{
                                            overflowY: "hidden",
                                            position: "relative",
                                            bottom: "8px",
                                            width: "100%",
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: false,
                                            },
                                          }}
                                        />
                                      </Index.DemoContainer>
                                    </Index.LocalizationProvider>
                                  </Index.Box>
                                  {errors?.applicationReceiveDate &&
                                    touched.applicationReceiveDate && (
                                      <p className="error-text">
                                        {errors?.applicationReceiveDate}
                                      </p>
                                    )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Typography
                                    component="p"
                                    className="in-label"
                                  >
                                    Filing Date*
                                  </Index.Typography>
                                  <Index.Box className="input-design-div with-border date-input-box">
                                    <Index.LocalizationProvider
                                      dateAdapter={Index.AdapterDayjs}
                                      sx={{ position: "absolute" }}
                                    >
                                      <Index.DemoContainer
                                        components={["DatePicker"]}
                                      >
                                        <Index.DatePicker
                                          name="formFillingDate"
                                          onChange={(value) => {
                                            setFieldValue(
                                              "formFillingDate",
                                              moment(value.$d).format(
                                                "YYYY-MM-DD"
                                              )
                                            );
                                          }}
                                          value={dayjs(values?.formFillingDate)}
                                          format="YYYY-MM-DD"
                                          sx={{
                                            overflowY: "hidden",
                                            position: "relative",
                                            bottom: "8px",
                                            width: "100%",
                                          }}
                                          slotProps={{
                                            textField: {
                                              size: "small",
                                              error: false,
                                            },
                                          }}
                                        />
                                      </Index.DemoContainer>
                                    </Index.LocalizationProvider>
                                  </Index.Box>
                                  {errors?.formFillingDate &&
                                    touched.formFillingDate && (
                                      <p className="error-text">
                                        {errors?.formFillingDate}
                                      </p>
                                    )}
                                </Index.Grid> */}
                              </Index.Grid>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="main-in-row">
                            <Index.Box className="user-basic">
                              <Index.Typography
                                component="p"
                                className="head-apply"
                              >
                                Family Members Details (પરિવારના સભ્યોની વિગતો)
                              </Index.Typography>
                            </Index.Box>
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups family-detail"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Name Of Applicant (અરજદારનું નામ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        value={values?.applicantId}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "applicantId",
                                            e.target.value,
                                          );

                                          setMemberDeatils(
                                            e.target.value,
                                            setFieldValue,
                                          );
                                          if (e.target.value) {
                                            getSahayApplicatOldBankDetailData(
                                              e.target.value,
                                              setFieldValue,
                                            );
                                          }

                                          // setFieldValue("bankName", "");
                                          // setFieldValue("branch", "");
                                          // setFieldValue("HolderName", "");
                                          // setFieldValue("IFSCCode", "");
                                          // setFieldValue("AccountNo", "");

                                          setApplicantId(e.target.value);
                                          setApplicantSelectedMember(
                                            familyMembers?.filter((item) => {
                                              return item?.id == e.target.value;
                                            }),
                                          );

                                          setFieldValue(
                                            "relationRecords",
                                            familyMembers?.filter((item) => {
                                              return (
                                                item?.id !== e.target.value
                                              );
                                            }),
                                          );
                                        }}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {familyMembers?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.id}
                                            value={ele?.id}
                                          >
                                            {`${ele?.firstName} ${ele.middleName} ${ele.lastName}`}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.applicantId &&
                                      touched?.applicantId && (
                                        <p className="error-text">
                                          {errors?.applicantId}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      {/* Beneficiary Name (લાભાર્થીનું નામ) */}
                                      {/* Patient Name ( દર્દીનું નામ) */}

                                        {sahayTypeList?.find(
                                          (data) =>
                                            +data?.Id == +values?.SahayType,
                                        )?.Sahay_category == "Medical Sahay"
                                          ? "Patient Name ( દર્દીનું નામ)"
                                          : "Beneficiary Name ( લાભાર્થીનું નામ)"}
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        value={values?.beneficiaryName}
                                        onChange={(e) => {
                                          setFieldValue(
                                            "beneficiaryName",
                                            e.target.value,
                                          );
                                        }}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {familyMembers?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.id}
                                            value={ele?.id}
                                          >
                                            {`${ele?.firstName} ${ele?.middleName} ${ele?.lastName}`}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.beneficiaryName &&
                                      touched?.beneficiaryName && (
                                        <p className="error-text">
                                          {errors?.beneficiaryName}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Name (નામ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="memberName"
                                      value={values?.memberName}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors?.memberName &&
                                      touched?.memberName && (
                                        <p className="error-text">
                                          {errors?.memberName}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Relation (સંબંધ)
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="relation"
                                      value={values?.relation}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors?.relation && touched?.relation && (
                                      <p className="error-text">
                                        {errors?.relation}
                                      </p>
                                    )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Age (ઉંમર)
                                    </Index.Typography>
                                    <Index.TextField
                                      disabled
                                      type="number"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="age"
                                      value={values?.age}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors?.age && touched?.age && (
                                      <p className="error-text">
                                        {errors?.age}
                                      </p>
                                    )}
                                  </Index.Box>
                                </Index.Grid>
                                {/* <Index.Grid item xs={12} sm={6} md={4} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Working Type
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="workingType"
                                      value={values?.workingType}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                    {errors?.workingType &&
                                      touched?.workingType && (
                                        <p className="error-text">
                                          {errors?.workingType}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={3}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Monthly Income
                                    </Index.Typography>
                                    <Index.TextField
                                      type="number"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="monthlyIncome"
                                      value={values?.monthlyIncome}
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                   
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                       Electric Bill amount 
                                      </Index.Typography>
                                      <Index.TextField
                                        type="number"
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="threeMonthBillAmount"
                                        value={values?.threeMonthBillAmount}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                      />
                                      {errors?.threeMonthBillAmount &&
                                        touched?.threeMonthBillAmount && (
                                          <p className="error-text">
                                            {errors?.threeMonthBillAmount}
                                          </p>
                                        )}
                                    </Index.Box>
                                  </Index.Grid> */}
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Working Type (કામ કરવાનો પ્રકાર)
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        name="workingType"
                                        value={values?.workingType}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {workingTypeList?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.id}
                                            value={ele?.name}
                                          >
                                            {ele?.name}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.workingType &&
                                      touched?.workingType && (
                                        <p className="error-text">
                                          {errors?.workingType}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Family Income (કૌટુંબિક આવક){" "}
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        name="monthlyIncome"
                                        value={values?.monthlyIncome}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {familyIncomeAmountList?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.id}
                                            value={ele?.ammount}
                                          >
                                            {ele?.ammount}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.monthlyIncome &&
                                      touched?.monthlyIncome && (
                                        <p className="error-text">
                                          {errors?.monthlyIncome}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Electric Bill amount (વીજળી બિલની રકમ){" "}
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.FormControl
                                      sx={{ width: "100%" }}
                                      className="main-select"
                                    >
                                      <Index.Select
                                        className="select-drop"
                                        displayEmpty
                                        name="threeMonthBillAmount"
                                        value={values?.threeMonthBillAmount}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        input={<OutlinedInput />}
                                        MenuProps={MenuProps}
                                        inputProps={{
                                          "aria-label": "Without label",
                                        }}
                                      >
                                        {electricBillAmountList?.map((ele) => (
                                          <Index.MenuItem
                                            key={ele?.id}
                                            value={ele?.ammount}
                                          >
                                            {ele?.ammount}
                                          </Index.MenuItem>
                                        ))}
                                      </Index.Select>
                                    </Index.FormControl>
                                    {errors?.threeMonthBillAmount &&
                                      touched?.threeMonthBillAmount && (
                                        <p className="error-text">
                                          {errors?.threeMonthBillAmount}
                                        </p>
                                      )}
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="main-in-row row-bank">
                            <Index.Box className="user-basic">
                              <Index.Typography
                                component="p"
                                className="head-apply"
                              >
                                Bank Details (બેંક વિગતો)
                              </Index.Typography>
                            </Index.Box>
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp bank-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                {/* {bankAccountsListData &&
                                  bankAccountsListData?.length > 0 && (
                                    <>
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={3}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Bank Account (બેંક ખાતું)
                                          </Index.Typography>
                                          <Index.FormControl
                                            sx={{ width: "100%" }}
                                            className="main-select"
                                          >
                                            <Index.Select
                                              className="select-drop"
                                              displayEmpty
                                              value={values?.bankMasterId}
                                              onChange={(e) => {
                                                setFieldValue(
                                                  "bankMasterId",
                                                  e.target.value
                                                );

                                                let data =
                                                  bankAccountsListData?.filter(
                                                    (ele) => {
                                                      return (
                                                        ele?.id ==
                                                        e.target.value
                                                      );
                                                    }
                                                  );

                                                if (data.length > 0) {
                                                  setFieldValue(
                                                    "bankName",
                                                    data[0]?.bankName
                                                  );
                                                  setFieldValue(
                                                    "branch",
                                                    data[0]?.branch
                                                  );
                                                  setFieldValue(
                                                    "HolderName",
                                                    data[0]?.HolderName
                                                  );
                                                  setFieldValue(
                                                    "IFSCCode",
                                                    data[0]?.IFSCCode
                                                  );
                                                  setFieldValue(
                                                    "AccountNo",
                                                    data[0]?.AccountNo
                                                  );
                                                }
                                              }}
                                              onBlur={handleBlur}
                                              input={<OutlinedInput />}
                                              // renderValue={(selected) => {
                                              //   if (selected.length === 0) {
                                              //     return <em>Dropdown</em>;
                                              //   }

                                              //   return selected.join(", ");
                                              // }}
                                              MenuProps={MenuProps}
                                              inputProps={{
                                                "aria-label": "Without label",
                                              }}
                                            >
                                              {bankAccountsListData &&
                                                bankAccountsListData?.map(
                                                  (ele) => (
                                                    <Index.MenuItem
                                                      key={ele?.id}
                                                      value={ele?.id}
                                                    >
                                                      {ele?.bankName}
                                                    </Index.MenuItem>
                                                  )
                                                )}
                                            </Index.Select>
                                          </Index.FormControl>
                                          {errors?.bankMasterId &&
                                            touched?.bankMasterId && (
                                              <p className="error-text">
                                                {errors?.bankMasterId}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>
                                    </>
                                  )} */}
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Bank Name (બેંકનું નામ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="bankName"
                                      value={values?.bankName}
                                      onChange={(e) => {
                                        const uppercaseValue =
                                          e.target.value.toUpperCase();
                                        handleChange(e.target.name)(
                                          uppercaseValue,
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.bankName && touched?.bankName && (
                                    <p className="error-text">
                                      {errors?.bankName}
                                    </p>
                                  )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Branch (શાખા)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="branch"
                                      value={values?.branch}
                                      onChange={(e) => {
                                        const uppercaseValue =
                                          e.target.value.toUpperCase();
                                        handleChange(e.target.name)(
                                          uppercaseValue,
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.branch && touched?.branch && (
                                    <p className="error-text">
                                      {errors?.branch}
                                    </p>
                                  )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Account Holder Name (ખાતાધારકનું નામ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      type="text"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="HolderName"
                                      value={values?.HolderName}
                                      onChange={(e) => {
                                        const uppercaseValue =
                                          e.target.value.toUpperCase();
                                        handleChange(e.target.name)(
                                          uppercaseValue,
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.HolderName &&
                                    touched?.HolderName && (
                                      <p className="error-text">
                                        {errors?.HolderName}
                                      </p>
                                    )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Account Number (એકાઉન્ટ નંબર){" "}
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      type="string"
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="AccountNo"
                                      value={values?.AccountNo}
                                      onChange={(e) => {
                                        const inputValue =
                                          e.target.value.replace(/\D/g, "");
                                        setFieldValue(
                                          "AccountNo",
                                          inputValue.slice(0, 18),
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.AccountNo && touched?.AccountNo && (
                                    <p className="error-text">
                                      {errors?.AccountNo}
                                    </p>
                                  )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      IFSC Code (IFSC કોડ)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="IFSCCode"
                                      value={values?.IFSCCode}
                                      onChange={(e) => {
                                        let uppercaseValue =
                                          e.target.value.toUpperCase();

                                        // Limit to 30 characters at JS level as well (in case of pasted text)
                                        if (uppercaseValue.length > 30) {
                                          uppercaseValue = uppercaseValue.slice(
                                            0,
                                            30,
                                          );
                                        }

                                        handleChange(e.target.name)(
                                          uppercaseValue,
                                        );
                                      }}
                                      onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                  {errors?.IFSCCode && touched?.IFSCCode && (
                                    <p className="error-text">
                                      {errors?.IFSCCode}
                                    </p>
                                  )}
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box className="main-in-row row-bank">
                            <Index.Box
                              sx={{ flexGrow: 1, marginTop: "20px" }}
                              className="al-form-groups fam-in-grp bank-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                {getSingleSubSahay != 1014 &&
                                  getSingleSubSahay != 1015 &&
                                  getSingleSubSahay != 1010 &&
                                  values?.isSahay == "Yes" && (
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Requested Sahay (સહાયને વિનંતી કરી)
                                        </Index.Typography>
                                        <Index.TextField
                                          type="number"
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="SahayAmmount"
                                          value={values?.SahayAmmount}
                                          onChange={handleChange}
                                          // onBlur={handleBlur}
                                        />
                                      </Index.Box>
                                      {/* {errors?.SahayAmmount &&
                                    touched?.SahayAmmount && (
                                      <p className="error-text">
                                        {errors?.SahayAmmount}
                                      </p>
                                    )} */}
                                    </Index.Grid>
                                  )}

                                {/* )} */}

                                {/* )
                              } */}
                                {/* {editData?.application?.[0]
                                  ?.rentSahayAmmount !== 0 && ( */}

                                {/* )} */}
                              </Index.Grid>
                            </Index.Box>
                            {/* 
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={8}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Remark
                                    </Index.Typography>
                                    <Index.TextField
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="remark"
                                      value={values?.remark}
                                      onChange={handleChange}
                                      // onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box> */}

                            {/* <Index.Grid
                              item
                              xs={4}
                              className="al-form-groups fam-in-grp"
                            ></Index.Grid> */}

                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp mb-0px-sahay"
                            >
                              <Index.Grid container spacing={2}>
                                {getSingleSubSahay != 1010 ? (
                                  <Index.Grid item xs={12} sm={6} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        {/* Total Claimed Sahay Amount */}
                                        Total Requested Sahay Amount (કુલ વિનંતી
                                        કરેલ રકમ)
                                      </Index.Typography>
                                      <Index.TextField
                                        disabled={
                                          getSingleSubSahay == 1014
                                            ? true
                                            : false
                                        }
                                        type="number"
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="claimedAmmount"
                                        value={
                                          getSingleSubSahay == 1014
                                            ? values?.mediclaimAmmount
                                            : values?.claimedAmmount
                                        }
                                        // value={values?.mediclaimAmmount}
                                        onChange={(e) => {
                                          if (e.target.value.length <= 7) {
                                            // Only update the value if it's not more than 40 characters
                                            handleChange(e);
                                          }
                                        }}
                                        onBlur={handleBlur}
                                      />
                                    </Index.Box>
                                    {/* {errors?.claimedAmmount &&
                                    touched?.claimedAmmount && (
                                      <p className="error-text">
                                        {errors?.claimedAmmount}
                                      </p>
                                    )} */}
                                  </Index.Grid>
                                ) : null}
                                <Index.Grid item xs={12} sm={8} md={8} lg={8}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      {/* Remark (ટિપ્પણી) */}
                                      Additional Comments (વધારાની ટિપ્પણીઓ)
                                    </Index.Typography>
                                    {/* <Index.TextField
                                        inputProps={ariaLabel}
                                        className="basic-input input-width"
                                        name="remark"
                                        value={values?.remark}
                                        onChange={handleChange}
                                        // onBlur={handleBlur}
                                      /> */}
                                    <Index.Textarea
                                      style={{
                                        fontSize: "15px",
                                        color: "black",
                                        padding: "4px",
                                        minHeight: "50px",
                                        width: "100%",
                                      }}
                                      minRows={1}
                                      inputProps={ariaLabel}
                                      className="basic-input input-width"
                                      name="remark"
                                      value={values?.remark}
                                      onChange={handleChange}
                                      // onBlur={handleBlur}
                                    />
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>

                            <Index.Box className="main-in-row">
                              <Index.Box className="user-basic">
                                <Index.Typography
                                  component="p"
                                  className="head-apply"
                                >
                                  Reference / Guarantor (સંદર્ભ / બાંયધરી આપનાર)
                                </Index.Typography>
                              </Index.Box>
                              <Index.Box
                                sx={{ flexGrow: 1 }}
                                className="al-form-groups family-detail"
                              >
                                <Index.Grid container spacing={2}>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Mobile Number (મોબાઈલ નંબર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          type="number"
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="patanMemberMobile"
                                          value={values?.patanMemberMobile}
                                          onChange={(e) => {
                                            const valueData =
                                              e.target.value?.slice(0, 10);
                                            setFieldValue(
                                              "patanMemberMobile",
                                              valueData,
                                            );
                                            setMobileDataForFamily(
                                              valueData?.length > 0
                                                ? valueData
                                                : editData?.application?.[0]
                                                    ?.patanMemberMobile,
                                            );
                                            if (valueData?.length == 10) {
                                              const familyData =
                                                familyListWithArea?.find(
                                                  (family) =>
                                                    family?.mem_mobile ==
                                                    valueData,
                                                );

                                              setFieldValue(
                                                "patanMandalMember",
                                                familyData?.mem_id
                                                  ? familyData?.mem_id
                                                  : "",
                                              );
                                            }
                                          }}
                                          onBlur={handleBlur}
                                        />
                                      </Index.Box>

                                      {errors?.patanMemberMobile &&
                                        touched?.patanMemberMobile && (
                                          <p className="error-text">
                                            {errors?.patanMemberMobile}
                                          </p>
                                        )}
                                    </Index.Box>
                                  </Index.Grid>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        FID (કૌટુંબિક આઈડી)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="patanMandalMember"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile,
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile,
                                                )?.mem_family_id
                                              : ""
                                          }
                                          disabled
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Reference / Guarantor (સંદર્ભ / બાંયધરી
                                        આપનાર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          className="basic-input input-width"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile,
                                            )
                                              ? `${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile,
                                                  )?.mem_fname
                                                } ${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile,
                                                  )?.mem_mname
                                                } ${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile,
                                                  )?.mem_lname
                                                }`
                                              : values?.patanReferenceName
                                          }
                                          name="patanReferenceName"
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceName",
                                              e.target.value,
                                            );
                                          }}
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile,
                                              ),
                                          }}
                                        />
                                      </Index.Box>

                                      {errors?.patanMandalMember &&
                                        touched?.patanMandalMember && (
                                          <p className="error-text">
                                            {errors?.patanMandalMember}
                                          </p>
                                        )}
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Mohalla Name (મોહલ્લાનું નામ)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile,
                                              ),
                                          }}
                                          className="basic-input input-width"
                                          name="patanReferenceMohollo"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile,
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile,
                                                )?.mohollo_name
                                              : values?.patanReferenceMohollo
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceMohollo",
                                              e.target.value,
                                            );
                                          }}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Area (વિસ્તાર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          className="basic-input input-width"
                                          name="patanReferenceArea"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile,
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile,
                                                )?.family_area
                                              : values?.patanReferenceArea
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceArea",
                                              e.target.value,
                                            );
                                          }}
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile,
                                              ),
                                          }}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Box>
                            {/* 
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Mobile Number (મોબાઈલ નંબર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          type="number"
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="patanMemberMobile"
                                          value={values?.patanMemberMobile}
                                          onChange={(e) => {
                                            const valueData =
                                              e.target.value?.slice(0, 10);
                                            setFieldValue(
                                              "patanMemberMobile",
                                              valueData
                                            );
                                            if (valueData?.length == 10) {
                                              const familyData =
                                                familyListWithArea?.find(
                                                  (family) =>
                                                    family?.mem_mobile ==
                                                    valueData
                                                );

                                              setFieldValue(
                                                "patanMandalMember",
                                                familyData?.mem_id
                                                  ? familyData?.mem_id
                                                  : ""
                                              );
                                            }
                                          }}
                                          onBlur={handleBlur}
                                        />
                                      </Index.Box>

                                      {errors?.patanMemberMobile &&
                                        touched?.patanMemberMobile && (
                                          <p className="error-text">
                                            {errors?.patanMemberMobile}
                                          </p>
                                        )}
                                    </Index.Box>
                                  </Index.Grid>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        FID (FID)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          inputProps={ariaLabel}
                                          className="basic-input input-width"
                                          name="patanMandalMember"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile
                                                )?.mem_family_id
                                              : ""
                                          }
                                          disabled
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>
                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Reference / Guarantor (સંદર્ભ / બાંયધરી
                                        આપનાર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          className="basic-input input-width"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile
                                            )
                                              ? `${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile
                                                  )?.mem_fname
                                                } ${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile
                                                  )?.mem_mname
                                                } ${
                                                  familyListWithArea.find(
                                                    (row) =>
                                                      row?.mem_mobile ==
                                                      values?.patanMemberMobile
                                                  )?.mem_lname
                                                }`
                                              : values?.patanReferenceName
                                          }
                                          name="patanReferenceName"
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceName",
                                              e.target.value
                                            );
                                          }}
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile
                                              ),
                                          }}
                                        />
                                      </Index.Box>

                                      {errors?.patanMandalMember &&
                                        touched?.patanMandalMember && (
                                          <p className="error-text">
                                            {errors?.patanMandalMember}
                                          </p>
                                        )}
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Mohalla Name (મોહલ્લાનું નામ)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile
                                              ),
                                          }}
                                          className="basic-input input-width"
                                          name="patanReferenceMohollo"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile
                                                )?.mohollo_name
                                              : values?.patanReferenceMohollo
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceMohollo",
                                              e.target.value
                                            );
                                          }}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>

                                  <Index.Grid item xs={12} sm={4} md={4} lg={4}>
                                    <Index.Box className="lable-input-grp">
                                      <Index.Typography
                                        component="p"
                                        className="in-label"
                                      >
                                        Area (વિસ્તાર)
                                      </Index.Typography>
                                      <Index.Box className="sahay-multiple-input-main">
                                        <Index.TextField
                                          className="basic-input input-width"
                                          name="patanReferenceArea"
                                          value={
                                            familyListWithArea?.find(
                                              (row) =>
                                                row?.mem_mobile ==
                                                values?.patanMemberMobile
                                            )
                                              ? familyListWithArea?.find(
                                                  (row) =>
                                                    row?.mem_mobile ==
                                                    values?.patanMemberMobile
                                                )?.family_area
                                              : values?.patanReferenceArea
                                          }
                                          onChange={(e) => {
                                            setFieldValue(
                                              "patanReferenceArea",
                                              e.target.value
                                            );
                                          }}
                                          inputProps={{
                                            ...ariaLabel,
                                            disabled:
                                              !!familyListWithArea?.find(
                                                (row) =>
                                                  row?.mem_mobile ===
                                                  values?.patanMemberMobile
                                              ),
                                          }}
                                        />
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Grid>
                                </Index.Grid>
                              </Index.Box>
                            </Index.Box>
                            {/* 
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups family-detail fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                {getSingleSubSahay !== 1014 ? (
                                  <>
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Does The Applicant Take Mediclaim
                                          Premium Sahay
                                        </Index.Typography>
                                        <Index.ToggleButtonGroup
                                          color="primary"
                                          value={values?.isSahay}
                                          exclusive
                                          onChange={(e) => {
                                            setFieldValue(
                                              "isSahay",
                                              e.target.value
                                            );
                                          }}
                                          aria-label="Platform"
                                          className="toggle-switch-main"
                                        >
                                          <Index.ToggleButton value={"Yes"}>
                                            Yes
                                          </Index.ToggleButton>
                                          <Index.ToggleButton value={"No"}>
                                            No
                                          </Index.ToggleButton>
                                        </Index.ToggleButtonGroup>
                                      </Index.Box>
                                    </Index.Grid>
                                    <Index.Grid
                                      item
                                      xs={12}
                                      sm={6}
                                      md={4}
                                      lg={3}
                                    >
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Does The Applicant Have A Mediclaim
                                          Policys
                                        </Index.Typography>
                                        <Index.ToggleButtonGroup
                                          color="primary"
                                          value={values?.isMediclaim}
                                          exclusive
                                          onChange={(e) => {
                                            setFieldValue(
                                              "isMediclaim",
                                              e.target.value
                                            );
                                          }}
                                          aria-label="Platform"
                                          className="toggle-switch-main"
                                        >
                                          <Index.ToggleButton value="Yes">
                                            Yes
                                          </Index.ToggleButton>
                                          <Index.ToggleButton value="No">
                                            No
                                          </Index.ToggleButton>
                                        </Index.ToggleButtonGroup>
                                      </Index.Box>
                                    </Index.Grid>
                                  </>
                                ) : null}
                              </Index.Grid>
                            </Index.Box> */}

                            {/* <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups family-detail fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={4}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                      sx={{ fontSize: "12px" }}
                                    >
                                      Does applicant took sahay from any trust
                                    </Index.Typography>
                                    <Index.ToggleButtonGroup
                                      color="primary"
                                      value={values?.trust}
                                      exclusive
                                      onChange={(e) => {
                                        setSahayCondition(e.target.value);
                                        setFieldValue("trust", e.target.value);
                                      }}
                                      aria-label="Platform"
                                      className="toggle-switch-main"
                                    >
                                      <Index.ToggleButton value="yes">
                                        Yes
                                      </Index.ToggleButton>
                                      <Index.ToggleButton value="no">
                                        No
                                      </Index.ToggleButton>
                                    </Index.ToggleButtonGroup>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box> */}
                            {/* 
                            {sahayCondition == "yes" && (
                              <>
                                <Index.Box
                                  sx={{ flexGrow: 1 }}
                                  className="al-form-groups fam-in-grp"
                                >
                                  <Index.Grid container spacing={2}>
                          
                                    <Index.Grid item xs={12}>
                                      <PagesIndex.FieldArray name="dataArray">
                                        {({ push, remove }) => (
                                          <div className="trust-main-div">
                                            <Index.Box className="common-button  mb-10px flex-end save-btn">
                                              <Index.Button
                                                variant="contained"
                                                onClick={() =>
                                                  push({
                                                    trustName: "",
                                                    ammount: 0,
                                                  })
                                                }
                                              >
                                                <Index.ControlPointIcon /> Add
                                                Trust
                                              </Index.Button>
                                            </Index.Box>

                                            {values?.dataArray?.map(
                                              (data, index) => (
                                                <Index.Grid
                                                  container
                                                  spacing={2}
                                                  key={index}
                                                  mb={2}
                                                >
                                                  <Index.Grid
                                                    item
                                                    xs={6}
                                                    sm={4}
                                                    md={4}
                                                    lg={3}
                                                  >
                                                    <Index.Box className="lable-input-grp">
                                                      <Index.Typography
                                                        component="p"
                                                        className="in-label"
                                                      >
                                                        Trust Name
                                                      </Index.Typography>
                                                      <Index.TextField
                                                        inputProps={ariaLabel}
                                                        className="basic-input input-width"
                                                        onBlur={handleBlur}
                                                        name={`dataArray.${index}.trustName`}
                                                        onChange={handleChange}
                                                        value={
                                                          values.dataArray[
                                                            index
                                                          ].trustName
                                                        }
                                                      />
                                                    </Index.Box>
                                                    {errors?.trustName &&
                                                      touched?.trustName && (
                                                        <p className="error-text">
                                                          {errors?.trustName}
                                                        </p>
                                                      )}
                                                  </Index.Grid>
                                                  <Index.Grid
                                                    item
                                                    xs={6}
                                                    sm={4}
                                                    md={4}
                                                    lg={3}
                                                  >
                                                    <Index.Box className="lable-input-grp">
                                                      <Index.Typography
                                                        component="p"
                                                        className="in-label"
                                                      >
                                                        Amount
                                                      </Index.Typography>
                                                      <Index.TextField
                                                        type="number"
                                                        inputProps={ariaLabel}
                                                        className="basic-input input-width"
                                                        onBlur={handleBlur}
                                                        name={`dataArray.${index}.ammount`}
                                                        onChange={handleChange}
                                                        value={
                                                          values.dataArray[
                                                            index
                                                          ].ammount
                                                        }
                                                      />
                                                    </Index.Box>
                                                    {errors?.ammount &&
                                                      touched?.ammount && (
                                                        <p className="error-text">
                                                          {errors?.ammount}
                                                        </p>
                                                      )}
                                                  </Index.Grid>

                                                  {index > 0 && (
                                                    <Index.Grid
                                                      item
                                                      xs={12}
                                                      sm={4}
                                                      md={4}
                                                      lg={3}
                                                    >
                                                      <Index.Box className="common-button mt-details-remove-pro ">
                                                        <Index.Button
                                                          variant="contained"
                                                          onClick={() =>
                                                            remove(index)
                                                          }
                                                        >
                                                          <RemoveIcon />
                                                        </Index.Button>
                                                      </Index.Box>{" "}
                                                    </Index.Grid>
                                                  )}
                                                </Index.Grid>
                                              )
                                            )}
                                          </div>
                                        )}
                                      </PagesIndex.FieldArray>
                                    </Index.Grid>

                                 
                                  </Index.Grid>
                                </Index.Box>
                              </>
                            )} */}

                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12} sm={6} md={5} lg={3}>
                                  <Index.Box className="lable-input-grp ">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Passport Size Photo (પાસપોર્ટ સાઇઝ ફોટો)
                                      <span className="required">*</span>
                                    </Index.Typography>
                                    <Index.Box className="select-position">
                                      <input
                                        type="file"
                                        name="passportPic"
                                        className="ori-input"
                                        onChange={(e) => {
                                          setFieldValue(
                                            "passportPic",
                                            e.target.files[0],
                                          );
                                          setSelectedImage(e.target.files[0]);
                                        }}
                                      />

                                      <Index.Box className="select-file">
                                        Upload Your Photo
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>

                                  {errors?.passportPic &&
                                    touched?.passportPic && (
                                      <p className="error-text">
                                        {errors?.passportPic}
                                      </p>
                                    )}
                                </Index.Grid>
                                <Index.Grid item xs={12} sm={6} md={5} lg={3}>
                                  <Index.Box className="lable-input-grp ">
                                    <Index.Box className="select-view">
                                      <Index.Typography
                                        component="p"
                                        className="document-name"
                                        style={{
                                          cursor: "pointer",
                                        }}
                                        onClick={() =>
                                          openSecureImageWithAuth(
                                            values?.passportPic?.name
                                              ? values?.passportPic.name
                                              : selectedImage
                                                ? selectedImage.name
                                                : values?.passportPic,
                                          )
                                        }
                                      >
                                        {/* {values?.passportPic?.name
                                          ? values?.passportPic.name
                                          : selectedImage
                                          ? selectedImage.name
                                          : values?.passportPic
                                          ? values?.passportPic
                                          : "Upload Your Photo"} */}

                                        {values?.passportPic?.name ? (
                                          values?.passportPic.name
                                        ) : selectedImage ? (
                                          selectedImage.name
                                        ) : values?.passportPic === "NULL" ? (
                                          <img
                                            src={
                                              PagesIndex.Png.sahayProfileImage
                                            }
                                            alt="img"
                                          />
                                        ) : (
                                          values?.passportPic
                                        )}
                                      </Index.Typography>
                                      {/* src=
                                      {selectedImage
                                        ? URL.createObjectURL(selectedImage)
                                        : `${imagePath}${editData?.application?.[0]?.image}`
                                        ? `${imagePath}${editData?.application?.[0]?.image}`
                                        : "https://cdn.landesa.org/wp-content/uploads/default-user-image.png"} */}
                                      {/* <img
                                        src={
                                          selectedImage
                                            ? URL.createObjectURL(selectedImage)
                                            : values?.passportPic
                                            ? `${imagePath}${values.passportPic}` // `/api/generate-image-url/${values.passportPic}`
                                            : // ? `${imagePath}${values.passportPic}`
                                              PagesIndex.Png.user_icon_default
                                        }
                                      /> */}
                                      <Index.Box
                                        className="select-remove"
                                        onClick={() =>
                                          resetImage(setFieldValue)
                                        }
                                      >
                                        Remove
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                            {/* {errors?.passportPic && touched?.passportPic && (
                            <p className="error-text">{errors?.passportPic}</p>
                          )} */}

                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp multiple-doc mt-0px-sahay{"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={12}>
                                  <Index.Box className="lable-input-grp">
                                    <Index.Typography
                                      component="p"
                                      className="in-label"
                                    >
                                      Add Multiple Document (બહુવિધ દસ્તાવેજો
                                      ઉમેરો)<span className="required">*</span>
                                    </Index.Typography>
                                    <Index.Box
                                      display="grid"
                                      className="display-row-add-user"
                                      gridTemplateColumns="repeat(12, 1fr)"
                                      gap={{ xs: 2, sm: 2, md: 2, lg: 2 }}
                                    >
                                      {values?.documents?.length > 0 && (
                                        <FieldArray name="documentData">
                                          {({ push, remove }) => (
                                            <>
                                              {values?.documents.map(
                                                (document, index) => (
                                                  <Index.Box
                                                    gridColumn={{
                                                      xs: "span 3",
                                                      sm: "span 3",
                                                      md: "span 3",
                                                      lg: "span 3",
                                                      xl: "span 3",
                                                    }}
                                                    className="grid-column"
                                                    key={document.documentType}
                                                  >
                                                    <Index.Box className="roles-data-box add-check-flex-doc">
                                                      <Index.Box className="add-role-flex">
                                                        {/* <Index.Checkbox
                                                         className="check-box-role"
                                                         checked={
                                                            document?.isUpload
                                                          }
                                                         onChange={() => {
                                                            setFieldValue(
                                                             `documents[${index}].isUpload`,
                                                             !document.isUpload
                                                                                               );
                                                           setFieldValue(
                                                              `documents[${index}].file`,
                                                             []
                                                           );
                                                         }}
  
                                                          // name={`${subSahay.subSahayName}-${document.documentType}`}
                                                        /> */}
                                                        <Index.Box className="role-data-title">
                                                          {
                                                            document.documentType
                                                          }
                                                          {document?.isRequired ===
                                                            true && (
                                                            <span className="required">
                                                              *
                                                            </span>
                                                          )}
                                                          {/* {document?.isUpload ===
                                                            true && (
                                                            <span className="required">
                                                              *
                                                            </span>
                                                          )} */}
                                                        </Index.Box>
                                                      </Index.Box>
                                                    </Index.Box>

                                                    {true && (
                                                      <>
                                                        <Index.Box className="select-position">
                                                          <input
                                                            multiple
                                                            type="file"
                                                            name="documents"
                                                            // multiple
                                                            className="ori-input"
                                                            onChange={(
                                                              event,
                                                            ) => {
                                                              const files =
                                                                event.target
                                                                  .files;
                                                              const allDocuments =
                                                                [
                                                                  ...values
                                                                    .documents[
                                                                    index
                                                                  ].file,
                                                                  ...files,
                                                                ]; // Concatenating existing files with newly selected files

                                                              setFieldValue(
                                                                `documents[${index}].file`,
                                                                allDocuments,
                                                              );
                                                            }}
                                                            onBlur={(event) => {
                                                              if (
                                                                values
                                                                  .documents[
                                                                  index
                                                                ].isUpload
                                                              ) {
                                                                handleBlur(
                                                                  event,
                                                                );
                                                              }
                                                            }}
                                                          />

                                                          <Index.Box className="select-file">
                                                            Upload Your Document
                                                          </Index.Box>

                                                          {errors?.documents?.[
                                                            index
                                                          ]?.file && (
                                                            <p className="error-text">
                                                              {
                                                                errors
                                                                  ?.documents?.[
                                                                  index
                                                                ]?.file
                                                              }
                                                            </p>
                                                          )}
                                                        </Index.Box>

                                                        {document.file?.length >
                                                          0 &&
                                                          document?.file?.map(
                                                            (
                                                              item,
                                                              fileIndex,
                                                            ) => {
                                                              return (
                                                                <Index.Box className="select-view-document-name mt-select-doc">
                                                                  <Index.Box className="document-name">
                                                                    <Index.Typography
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                      onClick={() =>
                                                                        openSecureImageWithAuth(
                                                                          item.filename,
                                                                        )
                                                                      }
                                                                      // onClick={() => {
                                                                      //   window.open(
                                                                      //     item instanceof
                                                                      //       Blob
                                                                      //       ? URL.createObjectURL(
                                                                      //           item
                                                                      //         )
                                                                      //       : // : `${imagePath}${values.documents[index].filePath}`
                                                                      //         `${imagePath}${item?.filename}`
                                                                      //   );
                                                                      // }}
                                                                    >
                                                                      {item instanceof
                                                                      Blob
                                                                        ? item.name
                                                                        : item?.document}
                                                                      {/* // : values
                                                                                                               //     .documents[
                                                                                                               //     index
                                                                                                               //   ]
                                                                                                               //     .file} */}
                                                                    </Index.Typography>
                                                                    <Index.IconButton
                                                                      onClick={() => {
                                                                        const updatedFiles =
                                                                          document.file?.filter(
                                                                            (
                                                                              ele,
                                                                              i,
                                                                            ) =>
                                                                              i !==
                                                                              fileIndex,
                                                                          );
                                                                        setFieldValue(
                                                                          `documents[${index}].file`,
                                                                          updatedFiles,
                                                                        );
                                                                      }}
                                                                    >
                                                                      <Index.ClearIcon className="muiico-cancel" />
                                                                    </Index.IconButton>
                                                                  </Index.Box>
                                                                </Index.Box>
                                                              );
                                                            },
                                                          )}
                                                      </>
                                                    )}
                                                  </Index.Box>
                                                ),
                                              )}
                                            </>
                                          )}
                                        </FieldArray>
                                      )}
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>

                            {values?.subSahayName?.toLowerCase() ==
                              "mediclaim premium sahay" && (
                              <>
                                {/* Policy Holders' Details Table */}
                                <Index.Box className="field-table user-basic">
                                  <Index.Typography
                                    component="p"
                                    className="head-apply"
                                  >
                                    Policy Holders' Details (પોલીસી ધારકોની
                                    વિગતઃ)
                                  </Index.Typography>
                                  <Index.TableContainer
                                    sx={{ maxHeight: 480 }}
                                    component={Index.Paper}
                                    className="table-container edit-drop-container scroll-table"
                                  >
                                    <Index.Table
                                      stickyHeader
                                      aria-label="sticky table"
                                      className="table-design-main barge-table edit-drop-table"
                                    >
                                      <Index.TableHead className="edit-drop-head">
                                        <Index.TableRow>
                                          <Index.TableCell align="center">
                                            Sr.
                                          </Index.TableCell>
                                          <Index.TableCell align="left">
                                            Full Name (પુરું નામ)
                                          </Index.TableCell>
                                          <Index.TableCell align="left">
                                            Relationship (સંબંધ)
                                          </Index.TableCell>
                                          <Index.TableCell align="left">
                                            Age (ઉંમર)
                                          </Index.TableCell>
                                          <Index.TableCell align="left">
                                            Sum Insured (વીમાની રકમ)
                                          </Index.TableCell>
                                          <Index.TableCell align="left">
                                            Total Premium (કુલ પ્રીમિયમ)
                                          </Index.TableCell>
                                          <Index.TableCell align="center">
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="policyHolders">
                                          {({ push, remove }) => (
                                            <>
                                              {values?.policyHolders?.map(
                                                (holder, index) => (
                                                  <Index.TableRow key={index}>
                                                    {/* Serial Number */}
                                                    <Index.TableCell
                                                      align="center"
                                                      className="tablecell"
                                                    >
                                                      {index + 1}.
                                                    </Index.TableCell>

                                                    {/* Full Name */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.TextField
                                                        placeholder="Full Name"
                                                        size="small"
                                                        inputProps={ariaLabel}
                                                        className="tablecell-field"
                                                        name={`policyHolders.${index}.fullName`}
                                                        value={
                                                          values.policyHolders[
                                                            index
                                                          ]?.fullName || ""
                                                        }
                                                        onChange={handleChange}
                                                        disabled={index === 0}
                                                      />
                                                    </Index.TableCell>

                                                    {/* Relationship */}

                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      {index == 0 ? (
                                                        <Index.TextField
                                                          placeholder="Relationship"
                                                          size="small"
                                                          inputProps={ariaLabel}
                                                          className="tablecell-field"
                                                          name={`policyHolders.${index}.relationship`}
                                                          value={
                                                            index === 0
                                                              ? "Applicant"
                                                              : values
                                                                  .policyHolders[
                                                                  index
                                                                ]
                                                                  ?.relationship ||
                                                                ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          disabled={index === 0}
                                                        />
                                                      ) : (
                                                        <Index.Box className="input-design-div with-border max-content-ellipsis">
                                                          <Index.Select
                                                            hiddenLabel
                                                            fullWidth
                                                            id="hgh"
                                                            value={
                                                              values
                                                                .policyHolders[
                                                                index
                                                              ]?.relationship
                                                            }
                                                            name={`policyHolders.${index}.relationship`}
                                                            onBlur={handleBlur}
                                                            onChange={
                                                              handleChange
                                                            }
                                                          >
                                                            {getRelationList &&
                                                              getRelationList?.map(
                                                                (option) => (
                                                                  <Index.MenuItem
                                                                    noWrap
                                                                    key={
                                                                      option.relation_id
                                                                    }
                                                                    value={
                                                                      option.relation_id
                                                                    }
                                                                    name={
                                                                      option.relation_name
                                                                    }
                                                                  >
                                                                    {
                                                                      option.relation_name
                                                                    }
                                                                  </Index.MenuItem>
                                                                ),
                                                              )}
                                                          </Index.Select>
                                                        </Index.Box>
                                                      )}
                                                    </Index.TableCell>

                                                    {/* Age */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.TextField
                                                        placeholder="Age"
                                                        size="small"
                                                        type="number"
                                                        inputProps={ariaLabel}
                                                        className="tablecell-field"
                                                        name={`policyHolders.${index}.age`}
                                                        value={
                                                          values.policyHolders[
                                                            index
                                                          ]?.age || ""
                                                        }
                                                        onChange={handleChange}
                                                        disabled={index === 0}
                                                      />
                                                    </Index.TableCell>

                                                    {/* Sum Insured */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.TextField
                                                        placeholder="Sum Insured"
                                                        size="small"
                                                        type="number"
                                                        inputProps={ariaLabel}
                                                        className="tablecell-field"
                                                        name={`policyHolders.${index}.sumInsured`}
                                                        value={
                                                          values.policyHolders[
                                                            index
                                                          ]?.sumInsured || ""
                                                        }
                                                        onChange={handleChange}
                                                      />
                                                    </Index.TableCell>

                                                    {/* Total Premium */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.TextField
                                                        placeholder="Total Premium"
                                                        size="small"
                                                        type="number"
                                                        inputProps={ariaLabel}
                                                        className="tablecell-field"
                                                        name={`policyHolders.${index}.totalPremium`}
                                                        value={
                                                          values.policyHolders[
                                                            index
                                                          ]?.totalPremium || ""
                                                        }
                                                        onChange={handleChange}
                                                      />
                                                    </Index.TableCell>

                                                    {/* Delete Button */}
                                                    <Index.TableCell
                                                      align="center"
                                                      className="tablecell"
                                                    >
                                                      {index > 0 && (
                                                        <Index.IconButton
                                                          onClick={() =>
                                                            remove(index)
                                                          }
                                                          color="error"
                                                          size="small"
                                                        >
                                                          <Index.DeleteIcon />
                                                        </Index.IconButton>
                                                      )}
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                ),
                                              )}

                                              {/* Add Member Button */}
                                              <Index.TableRow>
                                                <Index.TableCell colSpan={7}>
                                                  <Index.Button
                                                    variant="outlined"
                                                    onClick={() =>
                                                      push({
                                                        fullName: "",
                                                        relationship: "",
                                                        age: "",
                                                        sumInsured: "",
                                                        totalPremium: "",
                                                      })
                                                    }
                                                    fullWidth
                                                  >
                                                    + Add Member
                                                  </Index.Button>
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </>
                                          )}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>
                                </Index.Box>

                                {/* Insurance Information Section */}
                                <Index.Box className="main-in-row">
                                  <Index.Box className="user-basic"></Index.Box>
                                  <Index.Box
                                    sx={{ flexGrow: 1 }}
                                    className="al-form-groups family-detail"
                                  >
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                      sx={{ mb: 2, mt: 3 }}
                                    >
                                      Insurance Information (વીમા માહિતી)
                                    </Index.Typography>

                                    <Index.Grid container spacing={2}>
                                      {/* Insurance Co. Name */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Insurance Co. Name (ઈન્સ્યુરન્સ કું.
                                            નું નામ)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="insuranceCompanyName"
                                              value={
                                                values?.insuranceCompanyName ||
                                                ""
                                              }
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.insuranceCompanyName &&
                                            touched?.insuranceCompanyName && (
                                              <p className="error-text">
                                                {errors?.insuranceCompanyName}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Branch No. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Branch No. (બ્રાન્ચ નં.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="branchNumber"
                                              value={values?.branchNumber || ""}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.branchNumber &&
                                            touched?.branchNumber && (
                                              <p className="error-text">
                                                {errors?.branchNumber}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy No. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy No. (પોલીસી નં.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              className="basic-input input-width"
                                              value={values?.policyNumber || ""}
                                              name="policyNumber"
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              inputProps={ariaLabel}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.policyNumber &&
                                            touched?.policyNumber && (
                                              <p className="error-text">
                                                {errors?.policyNumber}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Place */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Place (સ્થળ)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="place"
                                              value={values?.place || ""}
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.place && touched?.place && (
                                            <p className="error-text">
                                              {errors?.place}
                                            </p>
                                          )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Total Premium Paid */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Total Premium Paid (Rs.) (ભરેલ કુલ
                                            પ્રીમિયમ રૂ.)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="totalPremiumPaid"
                                              type="number"
                                              value={
                                                values?.totalPremiumPaid || ""
                                              }
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.totalPremiumPaid &&
                                            touched?.totalPremiumPaid && (
                                              <p className="error-text">
                                                {errors?.totalPremiumPaid}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Term: From */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Term: From (પોલીસીની મુદત તા)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                              sx={{ position: "absolute" }}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="policyTermFrom"
                                                  onChange={(value) => {
                                                    setFieldValue(
                                                      "policyTermFrom",
                                                      value
                                                        ? moment(
                                                            value.$d,
                                                          ).format("YYYY-MM-DD")
                                                        : "",
                                                    );
                                                  }}
                                                  value={
                                                    values?.policyTermFrom
                                                      ? dayjs(
                                                          values.policyTermFrom,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    overflowY: "hidden",
                                                    position: "relative",
                                                    bottom: "8px",
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                          {errors?.policyTermFrom &&
                                            touched?.policyTermFrom && (
                                              <p className="error-text">
                                                {errors?.policyTermFrom}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Term: To */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Term: To (પોલીસીની મુદત સુધી)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                              sx={{ position: "absolute" }}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="policyTermTo"
                                                  onChange={(value) => {
                                                    setFieldValue(
                                                      "policyTermTo",
                                                      value
                                                        ? moment(
                                                            value.$d,
                                                          ).format("YYYY-MM-DD")
                                                        : "",
                                                    );
                                                  }}
                                                  value={
                                                    values?.policyTermTo
                                                      ? dayjs(
                                                          values.policyTermTo,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    overflowY: "hidden",
                                                    position: "relative",
                                                    bottom: "8px",
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                          {errors?.policyTermTo &&
                                            touched?.policyTermTo && (
                                              <p className="error-text">
                                                {errors?.policyTermTo}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Last Year Details: During the last year up to Rs. */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Last Year Details: During the last
                                            year up to Rs. (ગત વર્ષ દરમિયાન રૂ.
                                            સુધી)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.TextField
                                              inputProps={ariaLabel}
                                              className="basic-input input-width"
                                              name="lastYearAmount"
                                              type="number"
                                              value={
                                                values?.lastYearAmount || ""
                                              }
                                              onChange={handleChange}
                                              onBlur={handleBlur}
                                              fullWidth
                                            />
                                          </Index.Box>
                                          {errors?.lastYearAmount &&
                                            touched?.lastYearAmount && (
                                              <p className="error-text">
                                                {errors?.lastYearAmount}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Last Year Details: until Date */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            until Date (તારીખ સુધી)
                                          </Index.Typography>
                                          <Index.Box className="input-design-div with-border date-input-box">
                                            <Index.LocalizationProvider
                                              dateAdapter={Index.AdapterDayjs}
                                              sx={{ position: "absolute" }}
                                            >
                                              <Index.DemoContainer
                                                components={["DatePicker"]}
                                              >
                                                <Index.DatePicker
                                                  name="lastYearUntilDate"
                                                  onChange={(value) => {
                                                    setFieldValue(
                                                      "lastYearUntilDate",
                                                      value
                                                        ? moment(
                                                            value.$d,
                                                          ).format("YYYY-MM-DD")
                                                        : "",
                                                    );
                                                  }}
                                                  value={
                                                    values?.lastYearUntilDate
                                                      ? dayjs(
                                                          values.lastYearUntilDate,
                                                        )
                                                      : null
                                                  }
                                                  format="YYYY-MM-DD"
                                                  sx={{
                                                    overflowY: "hidden",
                                                    position: "relative",
                                                    bottom: "8px",
                                                    width: "100%",
                                                  }}
                                                  slotProps={{
                                                    textField: {
                                                      size: "small",
                                                      error: false,
                                                    },
                                                  }}
                                                />
                                              </Index.DemoContainer>
                                            </Index.LocalizationProvider>
                                          </Index.Box>
                                          {errors?.lastYearUntilDate &&
                                            touched?.lastYearUntilDate && (
                                              <p className="error-text">
                                                {errors?.lastYearUntilDate}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Policy Type */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Policy Type (પોલિસીનો પ્રકાર)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.FormControl
                                              sx={{ width: "100%" }}
                                              className="main-select"
                                            >
                                              <Index.Select
                                                className="select-drop"
                                                displayEmpty
                                                name="policyTypeSelect"
                                                value={
                                                  values?.policyTypeSelect || ""
                                                }
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                input={<Index.OutlinedInput />}
                                                MenuProps={MenuProps}
                                              >
                                                <Index.MenuItem value="">
                                                  <em>Select Type</em>
                                                </Index.MenuItem>
                                                <Index.MenuItem value="new">
                                                  New
                                                </Index.MenuItem>
                                                <Index.MenuItem value="renewal">
                                                  Renewal
                                                </Index.MenuItem>
                                              </Index.Select>
                                            </Index.FormControl>
                                          </Index.Box>
                                          {errors?.policyTypeSelect &&
                                            touched?.policyTypeSelect && (
                                              <p className="error-text">
                                                {errors?.policyTypeSelect}
                                              </p>
                                            )}
                                        </Index.Box>
                                      </Index.Grid>

                                      {/* Claim History */}
                                      <Index.Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        md={4}
                                        lg={4}
                                      >
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Claim History: Claim has been
                                            received (ક્લેઇમ મેળવેલ છે)
                                          </Index.Typography>
                                          <Index.Box className="sahay-multiple-input-main">
                                            <Index.RadioGroup
                                              row
                                              name="claimReceived"
                                              value={
                                                values?.claimReceived || ""
                                              }
                                              onChange={handleChange}
                                            >
                                              <Index.FormControlLabel
                                                value="yes"
                                                control={<Index.Radio />}
                                                label="Yes"
                                              />
                                              <Index.FormControlLabel
                                                value="no"
                                                control={<Index.Radio />}
                                                label="No"
                                              />
                                            </Index.RadioGroup>
                                          </Index.Box>
                                        </Index.Box>
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Box>

                                {/* Important Notes Section */}
                                <Index.Box
                                  className="notes-section"
                                  sx={{
                                    mt: 4,
                                    p: 2,
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                  }}
                                >
                                  <Index.Typography
                                    className="note-title"
                                    sx={{ fontWeight: "bold", mb: 2 }}
                                  >
                                    Important Notes (મહત્વની નોંધ)
                                  </Index.Typography>

                                  <Index.Box className="note-points">
                                    {/* Point 1 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (1) It is mandatory to send the receipt of
                                      the amount paid to the Insurance Co. and a
                                      photocopy of the policy along with the
                                      application form.
                                      <br />
                                      (ઈન્સ્યુરન્સ કું. માં ભરેલ રકમની રસીદ તથા
                                      પોલીસીની ઝેરોક્ષ, અરજી પત્રક સાથે મોકલવી
                                      જરૂરી છે.)
                                    </Index.Typography>

                                    {/* Point 2 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (2) This form must be filled and sent to
                                      the association's office within four
                                      months from the date of minimum payment.
                                      <br />
                                      (મિનિમમ લાયકાતની તારીખથી ચાર માસ સુધીમાં આ
                                      ફોર્મ ભરીને મંડળના કાર્યાલયમાં મોકલવા
                                      જરૂરી છે.)
                                    </Index.Typography>

                                    {/* Point 3 */}
                                    <Index.Typography
                                      className="note-point"
                                      sx={{ mb: 1.5 }}
                                    >
                                      (3) Applications received after that
                                      period will not be accepted.
                                      <br />
                                      (ત્યારબાદ મળેલ અરજી સ્વીકાર્ય ગણાશે નહીં.)
                                    </Index.Typography>

                                    {/* Point 4 - Radio buttons */}
                                    {/* <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography component="p">
                                        (4) Have you taken an SBI General
                                        Mediclaim Policy through the
                                        association?
                                        <br />
                                        (મંડળ દ્વારા SBI જનરલ મેડિકલેઈમ પોલીસી
                                        લીધી છે?)
                                      </Index.Typography>
                                      <Index.RadioGroup
                                        row
                                        name="sbiPolicyTaken"
                                        value={values?.sbiPolicyTaken || ""}
                                        onChange={handleChange}
                                      >
                                        <Index.FormControlLabel
                                          value="yes"
                                          control={<Index.Radio />}
                                          label="Yes (હા)"
                                        />
                                        <Index.FormControlLabel
                                          value="no"
                                          control={<Index.Radio />}
                                          label="No (ના)"
                                        />
                                      </Index.RadioGroup>
                                    </Index.Box> */}

                                    {/* Point 5 - Text input */}
                                    <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography
                                        component="p"
                                        sx={{ mb: 0.5 }}
                                      >
                                        (4) Reason for taking the policy (પોલીસી
                                        લેવાનું કારણ):
                                      </Index.Typography>
                                      <Index.TextField
                                        fullWidth
                                        name="policyReason"
                                        value={values?.policyReason || ""}
                                        onChange={handleChange}
                                        className="basic-input"
                                        placeholder="Enter reason..."
                                        multiline
                                        rows={2}
                                      />
                                    </Index.Box>

                                    {/* Point 6 - Radio buttons */}
                                    <Index.Box
                                      className="note-point-with-input"
                                      sx={{ mb: 1.5 }}
                                    >
                                      <Index.Typography
                                        component="p"
                                        sx={{ mb: 0.5 }}
                                      >
                                        (5) Policy Category (પોલીસીનો પ્રકાર):
                                      </Index.Typography>
                                      <Index.RadioGroup
                                        row
                                        name="policyCategory"
                                        value={values?.policyCategory || ""}
                                        onChange={handleChange}
                                      >
                                        <Index.FormControlLabel
                                          value="group"
                                          control={<Index.Radio />}
                                          label="Group Policy (ગ્રુપ પોલીસી)"
                                        />
                                        <Index.FormControlLabel
                                          value="individual"
                                          control={<Index.Radio />}
                                          label="Individual Policy (ઈન્ડીવિજ્યુઅલ પોલીસી)"
                                        />
                                      </Index.RadioGroup>
                                    </Index.Box>

                                    {/* Point 7 */}
                                    <Index.Typography
                                      component="p"
                                      className="note-point"
                                      sx={{
                                        fontWeight: "bold",
                                        color: "error.main",
                                      }}
                                    >
                                      (6) All details have been carefully
                                      verified in writing. Forms with incomplete
                                      details will not be considered.
                                      <br />
                                      (કોઈપણ વિગત ખોટી લખી છે તો તે માન્ય રહેશે
                                      નહીં. અધૂરી વિગતોવાળા ફોર્મ પર ધ્યાન
                                      આપવામાં આવશે નહીં.)
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>

                                {/* General Note */}
                                <Index.Box
                                  className="special-note"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    bgcolor: "#fff3cd",
                                    borderRadius: 1,
                                    border: "1px solid #ffc107",
                                  }}
                                >
                                  <Index.Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#856404",
                                      mb: 1,
                                    }}
                                  >
                                    General Note (સામાન્ય નોંધ):
                                  </Index.Typography>
                                  <Index.Typography sx={{ color: "#856404" }}>
                                    Please send a clear copy of policy to showing the 'Policy 
                                      start from' and 'policy end date' with premium paid receipt to Patan jain mandal marine drive 
                                      Office.
                                    <br />
                                    (કૃપા કરીને પૉલિસીની સ્પષ્ટ નકલ 'પૉલિસી 
                                    થી શરૂ' અને 'પૉલિસી સમાપ્તિ તારીખ' દર્શાવતી પ્રીમિયમ ચૂકવણીની રસીદ સાથે પાટણ જૈન મંડળ મરીન ડ્રાઇવ 
                                    ઑફિસને મોકલો.)
                                  </Index.Typography>
                                </Index.Box>
                              </>
                            )}

                            {values?.subSahayName?.toLowerCase() ==
                              "medicine sahay" && (
                              <>
                                {/* Guidelines and Instructions */}
                                <Index.Box
                                  className="guidelines-section"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    bgcolor: "#f5f5f5",
                                    borderRadius: 1,
                                  }}
                                >
                                  <Index.Typography
                                    component="h3"
                                    sx={{
                                      fontWeight: "bold",
                                      mb: 1.5,
                                      fontSize: "16px",
                                    }}
                                  >
                                    Guidelines and Instructions (માર્ગદર્શિકા
                                    અને સૂચનાઓ)
                                  </Index.Typography>

                                  <Index.Box
                                    component="ul"
                                    sx={{
                                      pl: 2,
                                      "& li": { mb: 0.5, fontSize: "14px" },
                                    }}
                                  >
                                    <li>
                                      A maximum of four months' worth of bills
                                      may be submitted with the application.
                                      <br />
                                      (અરજી સાથે મહત્તમ ચાર મહિનાના બિલ્સ સબમિટ
                                      કરી શકાય છે.)
                                    </li>
                                    <li>
                                      Applicant must provide original bills and
                                      a photocopy of the doctor's prescription.
                                      <br />
                                      (અરજદારે મૂળ બિલ્સ અને ડૉક્ટરના
                                      પ્રિસ્ક્રિપ્શનની ફોટોકોપી આપવી જરૂરી છે.)
                                    </li>
                                    <li>
                                      Detailed information regarding other
                                      expenses must be recorded on this back of
                                      the form.
                                      <br />
                                      (અન્ય ખર્ચા અંગેની વિગતવાર માહિતી આ
                                      ફોર્મની પાછળની બાજુએ નોંધવી જરૂરી છે.)
                                    </li>
                                    <li>
                                      Multiple claims may be submitted, but not
                                      more than once every six months.
                                      <br />
                                      (બહુવિધ દાવાઓ સબમિટ કરી શકાય છે, પરંતુ દર
                                      છ મહિનામાં એક વાર કરતાં વધુ નહીં.)
                                    </li>
                                    <li>
                                      Applications without a current
                                      prescription will not be considered.
                                      <br />
                                      (વર્તમાન પ્રિસ્ક્રિપ્શન વિનાની અરજીઓ પર
                                      વિચારણા કરવામાં આવશે નહીં.)
                                    </li>
                    
                                  </Index.Box>

                                  {/* Direct Medicine Scheme - Inline in Guidelines */}
                                  <Index.Box
                                    sx={{
                                      mt: 2,
                                      p: 2,
                                      bgcolor: "#fff3cd",
                                      borderRadius: 1,
                                      border: "1px solid #ffc107",
                                    }}
                                  >
                                    <Index.Grid
                                      container
                                      spacing={2}
                                      alignItems="center"
                                    >
                                      <Index.Grid item xs={12} sm={6}>
                                        <Index.Typography
                                          component="p"
                                          sx={{ fontWeight: "bold" }}
                                        >
                                          <strong>
                                            Direct Medicine Scheme:
                                          </strong>{" "}
                                          (ડાયરેક્ટ મેડિસિન યોજના)
                                        </Index.Typography>
                                      </Index.Grid>

                                      <Index.Grid item xs={12} sm={3}>
                                        <Index.Box>
                                          <Index.Typography
                                            component="span"
                                            sx={{ mr: 1 }}
                                          >
                                            Joined? (જોડાયા?)
                                          </Index.Typography>
                                          <Index.RadioGroup
                                            row
                                            name="directMedicineSchemeJoined"
                                            value={
                                              values?.directMedicineSchemeJoined ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          >
                                            <Index.FormControlLabel
                                              value="yes"
                                              control={
                                                <Index.Radio size="small" />
                                              }
                                              label="Yes (હા)"
                                            />
                                            <Index.FormControlLabel
                                              value="no"
                                              control={
                                                <Index.Radio size="small" />
                                              }
                                              label="No (ના)"
                                            />
                                          </Index.RadioGroup>
                                        </Index.Box>
                                      </Index.Grid>

                                      <Index.Grid item xs={12} sm={3}>
                                        {values?.directMedicineSchemeJoined ===
                                          "no" && (
                                          <Index.Box>
                                            <Index.Typography
                                              component="span"
                                              sx={{ mr: 1 }}
                                            >
                                              Reason (કારણ):
                                            </Index.Typography>
                                            <Index.TextField
                                              size="small"
                                              name="directMedicineSchemeReason"
                                              value={
                                                values?.directMedicineSchemeReason ||
                                                ""
                                              }
                                              onChange={handleChange}
                                              placeholder="Enter reason"
                                              sx={{ width: "100%" }}
                                            />
                                          </Index.Box>
                                        )}
                                      </Index.Grid>
                                    </Index.Grid>
                                  </Index.Box>
                                </Index.Box>

                                {/* Summary of Medical Bills Table */}
                                <Index.Box
                                  className="medical-bills-table"
                                  sx={{ mb: 3 }}
                                >
                                  <Index.Typography
                                    component="h3"
                                    sx={{
                                      fontWeight: "bold",
                                      mb: 2,
                                      fontSize: "16px",
                                    }}
                                  >
                                    Summary of Medical Bills (તબીબી બિલ્સનો
                                    સારાંશ)
                                  </Index.Typography>

                                  <Index.TableContainer
                                    component={Index.Paper}
                                    className="table-container medical-bills-container"
                                    sx={{ border: "1px solid #ddd" }}
                                  >
                                    <Index.Table className="table-design-main medical-bills-table">
                                      <Index.TableHead
                                        sx={{ bgcolor: "#f5f5f5" }}
                                      >
                                        <Index.TableRow>
                                          <Index.TableCell
                                            align="left"
                                            sx={{
                                              fontWeight: "bold",
                                              width: "40%",
                                            }}
                                          >
                                            Name of Medical Store
                                            <br />
                                            (તબીબી સ્ટોરનું નામ)
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            sx={{
                                              fontWeight: "bold",
                                              width: "30%",
                                            }}
                                          >
                                            Date
                                            <br />
                                            (તારીખ)
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="right"
                                            sx={{
                                              fontWeight: "bold",
                                              width: "30%",
                                            }}
                                          >
                                            Bill Amount
                                            <br />
                                            (બિલ રકમ)
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="medicalBills">
                                          {({ push, remove }) => (
                                            <>
                                              {values?.medicalBills?.map(
                                                (bill, index) => (
                                                  <Index.TableRow key={index}>
                                                    {/* Medical Store Name */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.TextField
                                                        placeholder="Medical Store Name"
                                                        size="small"
                                                        fullWidth
                                                        inputProps={ariaLabel}
                                                        name={`medicalBills.${index}.storeName`}
                                                        value={
                                                          values.medicalBills[
                                                            index
                                                          ]?.storeName || ""
                                                        }
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                      />
                                                      {errors?.medicalBills?.[
                                                        index
                                                      ]?.storeName &&
                                                        touched?.medicalBills?.[
                                                          index
                                                        ]?.storeName && (
                                                          <Index.Typography
                                                            variant="caption"
                                                            color="error"
                                                          >
                                                            {
                                                              errors
                                                                .medicalBills[
                                                                index
                                                              ].storeName
                                                            }
                                                          </Index.Typography>
                                                        )}
                                                    </Index.TableCell>

                                                    {/* Date */}
                                                    <Index.TableCell
                                                      align="left"
                                                      className="tablecell"
                                                    >
                                                      <Index.LocalizationProvider
                                                        dateAdapter={
                                                          Index.AdapterDayjs
                                                        }
                                                      >
                                                        <Index.DatePicker
                                                          name={`medicalBills.${index}.date`}
                                                          value={
                                                            values.medicalBills[
                                                              index
                                                            ]?.date
                                                              ? dayjs(
                                                                  values
                                                                    .medicalBills[
                                                                    index
                                                                  ].date,
                                                                )
                                                              : null
                                                          }
                                                          onChange={(value) => {
                                                            setFieldValue(
                                                              `medicalBills.${index}.date`,
                                                              value
                                                                ? value.format(
                                                                    "YYYY-MM-DD",
                                                                  )
                                                                : "",
                                                            );
                                                          }}
                                                          format="YYYY-MM-DD"
                                                          slotProps={{
                                                            textField: {
                                                              size: "small",
                                                              fullWidth: true,
                                                              error: Boolean(
                                                                errors
                                                                  ?.medicalBills?.[
                                                                  index
                                                                ]?.date &&
                                                                touched
                                                                  ?.medicalBills?.[
                                                                  index
                                                                ]?.date,
                                                              ),
                                                            },
                                                          }}
                                                        />
                                                      </Index.LocalizationProvider>
                                                      {errors?.medicalBills?.[
                                                        index
                                                      ]?.date &&
                                                        touched?.medicalBills?.[
                                                          index
                                                        ]?.date && (
                                                          <Index.Typography
                                                            variant="caption"
                                                            color="error"
                                                          >
                                                            {
                                                              errors
                                                                .medicalBills[
                                                                index
                                                              ].date
                                                            }
                                                          </Index.Typography>
                                                        )}
                                                    </Index.TableCell>

                                                    {/* Bill Amount */}
                                                    <Index.TableCell
                                                      align="right"
                                                      className="tablecell"
                                                    >
                                                      <Index.Box
                                                        sx={{
                                                          display: "flex",
                                                          alignItems: "center",
                                                          gap: 1,
                                                        }}
                                                      >
                                                        <Index.TextField
                                                          placeholder="Amount"
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          inputProps={{
                                                            ...ariaLabel,
                                                            min: 0,
                                                            step: 0.01,
                                                          }}
                                                          name={`medicalBills.${index}.amount`}
                                                          value={
                                                            values.medicalBills[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          onBlur={handleBlur}
                                                          sx={{
                                                            textAlign: "right",
                                                          }}
                                                        />
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.Box>
                                                      {errors?.medicalBills?.[
                                                        index
                                                      ]?.amount &&
                                                        touched?.medicalBills?.[
                                                          index
                                                        ]?.amount && (
                                                          <Index.Typography
                                                            variant="caption"
                                                            color="error"
                                                          >
                                                            {
                                                              errors
                                                                .medicalBills[
                                                                index
                                                              ].amount
                                                            }
                                                          </Index.Typography>
                                                        )}
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                ),
                                              )}

                                              {/* Add Row Button */}
                                              <Index.TableRow>
                                                <Index.TableCell colSpan={3}>
                                                  <Index.Button
                                                    variant="outlined"
                                                    onClick={() =>
                                                      push({
                                                        storeName: "",
                                                        date: "",
                                                        amount: "",
                                                      })
                                                    }
                                                    fullWidth
                                                  >
                                                    + Add Medical Bill (+ તબીબી
                                                    બિલ ઉમેરો)
                                                  </Index.Button>
                                                </Index.TableCell>
                                              </Index.TableRow>

                                              {/* Total Expenditure Row */}
                                              <Index.TableRow
                                                sx={{ bgcolor: "#f9f9f9" }}
                                              >
                                                <Index.TableCell
                                                  colSpan={2}
                                                  align="right"
                                                  sx={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                  }}
                                                >
                                                  Total Expenditure (કુલ ખર્ચ):
                                                </Index.TableCell>
                                                <Index.TableCell
                                                  align="right"
                                                  sx={{
                                                    fontWeight: "bold",
                                                    fontSize: "15px",
                                                  }}
                                                >
                                                  Rs.{" "}
                                                  {values?.medicalBills
                                                    ?.reduce(
                                                      (sum, bill) =>
                                                        sum +
                                                        (parseFloat(
                                                          bill.amount,
                                                        ) || 0),
                                                      0,
                                                    )
                                                    .toFixed(2)}
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </>
                                          )}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>
                                </Index.Box>

                                {/* Assistance from Other Organizations */}
                                <Index.Box
                                  className="assistance-section"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    border: "1px solid #ddd",
                                    borderRadius: 1,
                                  }}
                                >
                                  <Index.Typography
                                    component="h3"
                                    sx={{
                                      fontWeight: "bold",
                                      mb: 2,
                                      fontSize: "16px",
                                    }}
                                  >
                                    Assistance from Other Organizations (અન્ય
                                    સંસ્થાઓ તરફથી સહાય)
                                  </Index.Typography>

                                  <Index.Box sx={{ mb: 2 }}>
                                    <Index.Typography
                                      component="p"
                                      sx={{ mb: 1 }}
                                    >
                                      Have you received aid from other
                                      unions/organizations? [ ] Yes [ ] No
                                      <br />
                                      (શું તમે અન્ય યુનિયન/સંસ્થાઓ પાસેથી સહાય
                                      મેળવી છે? [ ] હા [ ] ના)
                                    </Index.Typography>

                                    <Index.RadioGroup
                                      row
                                      name="receivedAidFromOthers"
                                      value={
                                        values?.receivedAidFromOthers || ""
                                      }
                                      onChange={handleChange}
                                    >
                                      <Index.FormControlLabel
                                        value="yes"
                                        control={<Index.Radio />}
                                        label="Yes (હા)"
                                      />
                                      <Index.FormControlLabel
                                        value="no"
                                        control={<Index.Radio />}
                                        label="No (ના)"
                                      />
                                    </Index.RadioGroup>
                                  </Index.Box>

                                  {/* Conditional rendering when Yes is selected */}
                                  {values?.receivedAidFromOthers === "yes" && (
                                    <Index.Box className="assistance-details">
                                      <Index.Grid container spacing={2}>
                                        <Index.Grid item xs={12} sm={6}>
                                          <Index.Box>
                                            <Index.Typography
                                              component="p"
                                              sx={{ mb: 0.5 }}
                                            >
                                              1. Name (નામ):
                                            </Index.Typography>
                                            <Index.TextField
                                              fullWidth
                                              size="small"
                                              name="assistanceOrg1Name"
                                              value={
                                                values?.assistanceOrg1Name || ""
                                              }
                                              onChange={handleChange}
                                              placeholder="Organization Name"
                                            />
                                          </Index.Box>
                                        </Index.Grid>

                                        <Index.Grid item xs={12} sm={6}>
                                          <Index.Box>
                                            <Index.Typography
                                              component="p"
                                              sx={{ mb: 0.5 }}
                                            >
                                              Amount (રકમ):
                                            </Index.Typography>
                                            <Index.TextField
                                              fullWidth
                                              size="small"
                                              type="number"
                                              name="assistanceOrg1Amount"
                                              value={
                                                values?.assistanceOrg1Amount ||
                                                ""
                                              }
                                              onChange={handleChange}
                                              placeholder="Amount"
                                              inputProps={{
                                                min: 0,
                                                step: 0.01,
                                              }}
                                            />
                                          </Index.Box>
                                        </Index.Grid>

                                        <Index.Grid item xs={12} sm={6}>
                                          <Index.Box>
                                            <Index.Typography
                                              component="p"
                                              sx={{ mb: 0.5 }}
                                            >
                                              2. Name (નામ):
                                            </Index.Typography>
                                            <Index.TextField
                                              fullWidth
                                              size="small"
                                              name="assistanceOrg2Name"
                                              value={
                                                values?.assistanceOrg2Name || ""
                                              }
                                              onChange={handleChange}
                                              placeholder="Organization Name"
                                            />
                                          </Index.Box>
                                        </Index.Grid>

                                        <Index.Grid item xs={12} sm={6}>
                                          <Index.Box>
                                            <Index.Typography
                                              component="p"
                                              sx={{ mb: 0.5 }}
                                            >
                                              Amount (રકમ):
                                            </Index.Typography>
                                            <Index.TextField
                                              fullWidth
                                              size="small"
                                              type="number"
                                              name="assistanceOrg2Amount"
                                              value={
                                                values?.assistanceOrg2Amount ||
                                                ""
                                              }
                                              onChange={handleChange}
                                              placeholder="Amount"
                                              inputProps={{
                                                min: 0,
                                                step: 0.01,
                                              }}
                                            />
                                          </Index.Box>
                                        </Index.Grid>
                                      </Index.Grid>
                                    </Index.Box>
                                  )}
                                </Index.Box>

                                {/* General Note */}
                                <Index.Box
                                  className="special-note"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    bgcolor: "#fff3cd",
                                    borderRadius: 1,
                                    border: "1px solid #ffc107",
                                  }}
                                >
                                  <Index.Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#856404",
                                      mb: 1,
                                    }}
                                  >
                                    General Note (સામાન્ય નોંધ):
                                  </Index.Typography>
                                  <Index.Typography sx={{ color: "#856404" }}>
                                    Please send all original bills with rubber stamp to       
                                      Patan jain mandal marine drive office.
                                    <br />
                                    (કૃપા કરીને બધા મૂળ બિલ રબર સ્ટેમ્પ સાથે 
                                      પાટણ જૈન મંડળ મરીન ડ્રાઇવ ઓફિસને મોકલો.)
                                  </Index.Typography>
                                </Index.Box>
                              </>
                            )}

                            {values?.subSahayName?.toLowerCase() ==
                              "medical sahay" && (
                              <>
                                {/* Special Note */}
                                <Index.Box
                                  className="special-note"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    bgcolor: "#fff3cd",
                                    borderRadius: 1,
                                    border: "1px solid #ffc107",
                                  }}
                                >
                                  <Index.Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#856404",
                                      mb: 1,
                                    }}
                                  >
                                    Special Note (વિશેષ નોંધ):
                                  </Index.Typography>
                                  <Index.Typography sx={{ color: "#856404" }}>
                                    If the applicant is married and the male
                                    member of the household is alive, the
                                    application must be made in his name.
                                    <br />
                                    (જો અરજદાર પરણીત હોય અને ઘરના પુરુષ સભ્ય
                                    જીવતા હોય, તો અરજી તેમના નામે કરવી જરૂરી
                                    છે.)
                                  </Index.Typography>
                                </Index.Box>

                                {/* Details of Applicant and Family Members */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Details of the Applicant and Persons
                                      Residing with Them (અરજદાર અને તેમની સાથે
                                      રહેતા વ્યક્તિઓની વિગતો)
                                    </Index.Typography>
                                  </Index.Box>

                                  {/* Family Members Table */}
                                  <Index.TableContainer
                                    component={Index.Paper}
                                    className="table-container"
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Table className="table-design-main">
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>No.</Index.TableCell>
                                          <Index.TableCell>
                                            Full Name (પુરું નામ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Relation (સંબંધ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Age (ઉંમર)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Current Activity (વર્તમાન પ્રવૃત્તિ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Monthly Income (માસિક આવક)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="familyMembersDetails">
                                          {({ push, remove }) => (
                                            <>
                                              {values?.familyMembersDetails?.map(
                                                (member, index) => (
                                                  <Index.TableRow key={index}>
                                                    <Index.TableCell>
                                                      {index + 1}
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      <Index.TextField
                                                        disabled={index == 0}
                                                        size="small"
                                                        fullWidth
                                                        name={`familyMembersDetails.${index}.fullName`}
                                                        value={
                                                          values
                                                            .familyMembersDetails[
                                                            index
                                                          ]?.fullName || ""
                                                        }
                                                        onChange={handleChange}
                                                        placeholder="Full Name"
                                                      />
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      {index == 0 ? (
                                                        <Index.TextField
                                                          disabled={index == 0}
                                                          size="small"
                                                          fullWidth
                                                          name={`familyMembersDetails.${index}.relation`}
                                                          value={
                                                            values
                                                              .familyMembersDetails[
                                                              index
                                                            ]?.relation || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          placeholder="Full Name"
                                                        />
                                                      ) : (
                                                        <Index.Select
                                                          size="small"
                                                          fullWidth
                                                          name={`familyMembersDetails.${index}.relation`}
                                                          value={
                                                            values
                                                              .familyMembersDetails[
                                                              index
                                                            ]?.relation || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        >
                                                          {getRelationList?.map(
                                                            (option) => (
                                                              <Index.MenuItem
                                                                key={
                                                                  option.relation_id
                                                                }
                                                                value={
                                                                  option.relation_id
                                                                }
                                                              >
                                                                {
                                                                  option.relation_name
                                                                }
                                                              </Index.MenuItem>
                                                            ),
                                                          )}
                                                        </Index.Select>
                                                      )}
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      <Index.TextField
                                                        disabled={index == 0}
                                                        size="small"
                                                        type="number"
                                                        fullWidth
                                                        name={`familyMembersDetails.${index}.age`}
                                                        value={
                                                          values
                                                            .familyMembersDetails[
                                                            index
                                                          ]?.age || ""
                                                        }
                                                        onChange={handleChange}
                                                        placeholder="Age"
                                                      />
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      <Index.TextField
                                                        size="small"
                                                        fullWidth
                                                        name={`familyMembersDetails.${index}.currentActivity`}
                                                        value={
                                                          values
                                                            .familyMembersDetails[
                                                            index
                                                          ]?.currentActivity ||
                                                          ""
                                                        }
                                                        onChange={handleChange}
                                                        placeholder="Current Activity"
                                                      />
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      <Index.TextField
                                                        size="small"
                                                        type="number"
                                                        fullWidth
                                                        name={`familyMembersDetails.${index}.monthlyIncome`}
                                                        value={
                                                          values
                                                            .familyMembersDetails[
                                                            index
                                                          ]?.monthlyIncome || ""
                                                        }
                                                        onChange={handleChange}
                                                        placeholder="Monthly Income"
                                                      />
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      {index > 0 && (
                                                        <Index.IconButton
                                                          onClick={() =>
                                                            remove(index)
                                                          }
                                                          color="error"
                                                          size="small"
                                                        >
                                                          <Index.DeleteIcon />
                                                        </Index.IconButton>
                                                      )}
                                                    </Index.TableCell>
                                                  </Index.TableRow>
                                                ),
                                              )}

                                              <Index.TableRow>
                                                <Index.TableCell colSpan={7}>
                                                  <Index.Button
                                                    variant="outlined"
                                                    onClick={() =>
                                                      push({
                                                        fullName: "",
                                                        relation: "",
                                                        age: "",
                                                        currentActivity: "",
                                                        monthlyIncome: "",
                                                      })
                                                    }
                                                    fullWidth
                                                  >
                                                    + Add Family Member
                                                  </Index.Button>
                                                </Index.TableCell>
                                              </Index.TableRow>
                                            </>
                                          )}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>

                                  {/* Additional Family Info */}
                                  <Index.Grid
                                    container
                                    spacing={2}
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Total family members (કુલ કુટુંબના
                                          સભ્યો)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="totalFamilyMembers"
                                          value={
                                            values?.totalFamilyMembers || ""
                                          }
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        {errors?.totalFamilyMembers &&
                                          touched?.totalFamilyMembers && (
                                            <p className="error-text">
                                              {errors?.totalFamilyMembers}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Earning members of the family
                                          (કુટુંબના કમાતા સભ્યો)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="earningMembers"
                                          value={values?.earningMembers || ""}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        {errors?.earningMembers &&
                                          touched?.earningMembers && (
                                            <p className="error-text">
                                              {errors?.earningMembers}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>
                                  </Index.Grid>
                                </Index.Box>

                                {/* Medical Details */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Medical Details (તબીબી વિગતો)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Grid container spacing={2}>
                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Details of main ailment (મુખ્ય
                                          બિમારીની વિગત)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          multiline
                                          rows={3}
                                          name="mainAilmentDetails"
                                          value={
                                            values?.mainAilmentDetails || ""
                                          }
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        {errors?.mainAilmentDetails &&
                                          touched?.mainAilmentDetails && (
                                            <p className="error-text">
                                              {errors?.mainAilmentDetails}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Details of other ailments (અન્ય
                                          બિમારીઓની વિગત)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          multiline
                                          rows={3}
                                          name="otherAilmentsDetails"
                                          value={
                                            values?.otherAilmentsDetails || ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Duration of illness (બિમારીનો સમયગાળો)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="illnessDuration"
                                          value={values?.illnessDuration || ""}
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                          placeholder="e.g., 6 months"
                                        />
                                        {errors?.illnessDuration &&
                                          touched?.illnessDuration && (
                                            <p className="error-text">
                                              {errors?.illnessDuration}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Family Doctor's name (કૌટુંબિક
                                          ડોક્ટરનું નામ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="familyDoctorName"
                                          value={values?.familyDoctorName || ""}
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Doctor's Mobile No. (ડોક્ટરનો મોબાઇલ
                                          નં.)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="tel"
                                          name="familyDoctorMobile"
                                          value={
                                            values?.familyDoctorMobile || ""
                                          }
                                          onChange={(e) => {
                                            const value = e.target.value
                                              .replace(/\D/g, "")
                                              .slice(0, 10);
                                            setFieldValue(
                                              "familyDoctorMobile",
                                              value,
                                            );
                                          }}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Has an operation been performed/is it
                                          to be performed? (શું ઓપરેશન થયું
                                          છે/થવાનું છે?)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="operationPerformed"
                                          value={
                                            values?.operationPerformed || ""
                                          }
                                          onChange={handleChange}
                                          placeholder="Yes/No, details"
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Doctor/Consultant's name
                                          (ડૉક્ટર/સલાહકારનું નામ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="doctorConsultantName"
                                          value={
                                            values?.doctorConsultantName || ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Hospital/Nursing Home name
                                          (હૉસ્પિટલ/નર્સિંગ હોમનું નામ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="hospitalNursingHomeName"
                                          value={
                                            values?.hospitalNursingHomeName ||
                                            ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>
                                  </Index.Grid>
                                </Index.Box>

                                {/* Expense Details */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Expense Details (ખર્ચાની વિગત)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Grid container spacing={3}>
                                    {/* Medication Expenses */}
                                    <Index.Grid item xs={12} md={6}>
                                      <Index.Typography
                                        variant="h6"
                                        sx={{ mb: 2 }}
                                      >
                                        Medication Expense (દવાનો ખર્ચ)
                                      </Index.Typography>

                                      <PagesIndex.FieldArray name="medicationExpenses">
                                        {({ push, remove }) => (
                                          <>
                                            {values?.medicationExpenses?.map(
                                              (expense, index) => (
                                                <Index.Grid
                                                  container
                                                  spacing={2}
                                                  key={index}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <Index.Grid item xs={7}>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      name={`medicationExpenses.${index}.description`}
                                                      value={
                                                        values
                                                          .medicationExpenses[
                                                          index
                                                        ]?.description || ""
                                                      }
                                                      onChange={handleChange}
                                                      placeholder="Description"
                                                    />
                                                  </Index.Grid>
                                                  <Index.Grid item xs={4}>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      type="number"
                                                      name={`medicationExpenses.${index}.amount`}
                                                      value={
                                                        values
                                                          .medicationExpenses[
                                                          index
                                                        ]?.amount || ""
                                                      }
                                                      onChange={handleChange}
                                                      placeholder="Amount"
                                                    />
                                                  </Index.Grid>
                                                  <Index.Grid item xs={1}>
                                                    {index >= 4 && (
                                                      <Index.IconButton
                                                        onClick={() =>
                                                          remove(index)
                                                        }
                                                        color="error"
                                                        size="small"
                                                      >
                                                        <Index.DeleteIcon />
                                                      </Index.IconButton>
                                                    )}
                                                  </Index.Grid>
                                                </Index.Grid>
                                              ),
                                            )}
                                            <Index.Button
                                              variant="outlined"
                                              size="small"
                                              onClick={() =>
                                                push({
                                                  description: "",
                                                  amount: "",
                                                })
                                              }
                                            >
                                              + Add Medication Expense
                                            </Index.Button>
                                          </>
                                        )}
                                      </PagesIndex.FieldArray>
                                    </Index.Grid>

                                    {/* Hospital Treatment Expenses */}
                                    <Index.Grid item xs={12} md={6}>
                                      <Index.Typography
                                        variant="h6"
                                        sx={{ mb: 2 }}
                                      >
                                        Hospital Treatment Expense (હોસ્પિટલ
                                        ટ્રીટમેન્ટ ખર્ચ)
                                      </Index.Typography>

                                      <PagesIndex.FieldArray name="hospitalExpenses">
                                        {({ push, remove }) => (
                                          <>
                                            {values?.hospitalExpenses?.map(
                                              (expense, index) => (
                                                <Index.Grid
                                                  container
                                                  spacing={2}
                                                  key={index}
                                                  sx={{ mb: 2 }}
                                                >
                                                  <Index.Grid item xs={7}>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      name={`hospitalExpenses.${index}.description`}
                                                      value={
                                                        values.hospitalExpenses[
                                                          index
                                                        ]?.description || ""
                                                      }
                                                      onChange={handleChange}
                                                      placeholder="Description"
                                                    />
                                                  </Index.Grid>
                                                  <Index.Grid item xs={4}>
                                                    <Index.TextField
                                                      fullWidth
                                                      size="small"
                                                      type="number"
                                                      name={`hospitalExpenses.${index}.amount`}
                                                      value={
                                                        values.hospitalExpenses[
                                                          index
                                                        ]?.amount || ""
                                                      }
                                                      onChange={handleChange}
                                                      placeholder="Amount"
                                                    />
                                                  </Index.Grid>
                                                  <Index.Grid item xs={1}>
                                                    {index >= 3 && (
                                                      <Index.IconButton
                                                        onClick={() =>
                                                          remove(index)
                                                        }
                                                        color="error"
                                                        size="small"
                                                      >
                                                        <Index.DeleteIcon />
                                                      </Index.IconButton>
                                                    )}
                                                  </Index.Grid>
                                                </Index.Grid>
                                              ),
                                            )}
                                            <Index.Button
                                              variant="outlined"
                                              size="small"
                                              onClick={() =>
                                                push({
                                                  description: "",
                                                  amount: "",
                                                })
                                              }
                                            >
                                              + Add Hospital Expense
                                            </Index.Button>
                                          </>
                                        )}
                                      </PagesIndex.FieldArray>
                                    </Index.Grid>
                                  </Index.Grid>
                                </Index.Box>

                                {/* Hospital Stay Details */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Hospital Stay Details (હોસ્પિટલમાં રોકાણની
                                      વિગત)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Grid container spacing={2}>
                                    <Index.Grid item xs={12} sm={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Hospital Class (હોસ્પિટલ વર્ગ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="hospitalClass"
                                          value={values?.hospitalClass || ""}
                                          onChange={handleChange}
                                          placeholder="e.g., General, Private"
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          How many days? (કેટલા દિવસ?)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="hospitalDays"
                                          value={values?.hospitalDays || ""}
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Daily charge (દૈનિક ચાર્જ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="dailyCharge"
                                          value={values?.dailyCharge || ""}
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          If stayed in ICU, for how many days?
                                          (ICU માં રહ્યા હોય તો કેટલા દિવસ?)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="icuDays"
                                          value={values?.icuDays || ""}
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          ICU Daily charge (ICU દૈનિક ચાર્જ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="number"
                                          name="icuDailyCharge"
                                          value={values?.icuDailyCharge || ""}
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Reason for treatment (સારવારનું કારણ)
                                        </Index.Typography>
                                        <Index.RadioGroup
                                          row
                                          name="treatmentReason"
                                          value={values?.treatmentReason || ""}
                                          onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="diagnosis"
                                            control={<Index.Radio />}
                                            label="Diagnosis (નિદાન)"
                                          />
                                          <Index.FormControlLabel
                                            value="accident"
                                            control={<Index.Radio />}
                                            label="Accident (અકસ્માત)"
                                          />
                                          <Index.FormControlLabel
                                            value="infection"
                                            control={<Index.Radio />}
                                            label="Infection (ચેપ)"
                                          />
                                          <Index.FormControlLabel
                                            value="surgery"
                                            control={<Index.Radio />}
                                            label="Surgery (શસ્ત્રક્રિયા)"
                                          />
                                          <Index.FormControlLabel
                                            value="corona"
                                            control={<Index.Radio />}
                                            label="Corona (કોરોના)"
                                          />
                                          <Index.FormControlLabel
                                            value="other"
                                            control={<Index.Radio />}
                                            label="Other (અન્ય)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>
                                    </Index.Grid>
                                  </Index.Grid>
                                </Index.Box>

                                {/* Mediclaim Policy Details */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Mediclaim Policy Details (મેડિક્લેમ
                                      પોલિસીની વિગત)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Grid container spacing={2}>
                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Does the person have a Mediclaim
                                          policy? (શું વ્યક્તિ પાસે મેડિક્લેમ
                                          પોલિસી છે?)
                                        </Index.Typography>
                                        <Index.RadioGroup
                                          row
                                          name="mediclaimPolicyTaken"
                                          value={
                                            values?.mediclaimPolicyTaken || ""
                                          }
                                          onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="yes"
                                            control={<Index.Radio />}
                                            label="Yes (હા)"
                                          />
                                          <Index.FormControlLabel
                                            value="no"
                                            control={<Index.Radio />}
                                            label="No (ના)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>
                                    </Index.Grid>

                                    {values?.mediclaimPolicyTaken === "yes" && (
                                      <Index.Grid item xs={12} sm={6} md={4}>
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Amount of Mediclaim policy
                                            (મેડિક્લેમ પોલિસીની રકમ)
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            type="number"
                                            name="mediclaimPolicyAmount"
                                            value={
                                              values?.mediclaimPolicyAmount ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    )}

                                    <Index.Grid item xs={12} sm={6} md={4}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Has the Mediclaim policy provided by
                                          the association been taken? (શું
                                          સંસ્થા દ્વારા પૂરી પાડવામાં આવેલી
                                          મેડિક્લેમ પોલિસી લીધી છે?)
                                        </Index.Typography>
                                        <Index.RadioGroup
                                          row
                                          name="associationMediclaimTaken"
                                          value={
                                            values?.associationMediclaimTaken ||
                                            ""
                                          }
                                          onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="yes"
                                            control={<Index.Radio />}
                                            label="Yes (હા)"
                                          />
                                          <Index.FormControlLabel
                                            value="no"
                                            control={<Index.Radio />}
                                            label="No (ના)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>
                                    </Index.Grid>

                                    {values?.associationMediclaimTaken ===
                                      "yes" && (
                                      <Index.Grid item xs={12} sm={6} md={4}>
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Amount (રકમ)
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            type="number"
                                            name="associationMediclaimAmount"
                                            value={
                                              values?.associationMediclaimAmount ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    )}

                                    {values?.associationMediclaimTaken ===
                                      "no" && (
                                      <Index.Grid item xs={12}>
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            If Mediclaim policy is not taken,
                                            state the reason (જો મેડિક્લેમ
                                            પોલિસી લેવામાં ન આવી હોય, તો કારણ
                                            જણાવો)
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            multiline
                                            rows={2}
                                            name="mediclaimNotTakenReason"
                                            value={
                                              values?.mediclaimNotTakenReason ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    )}

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Has Mediclaim policy premium
                                          assistance been obtained from the
                                          association? (શું સંસ્થા પાસેથી
                                          મેડિક્લેમ પોલિસી પ્રીમિયમ સહાય
                                          મેળવવામાં આવી છે?)
                                        </Index.Typography>
                                        <Index.RadioGroup
                                          row
                                          name="mediclaimPremiumAssistance"
                                          value={
                                            values?.mediclaimPremiumAssistance ||
                                            ""
                                          }
                                          onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="yes"
                                            control={<Index.Radio />}
                                            label="Yes (હા)"
                                          />
                                          <Index.FormControlLabel
                                            value="no"
                                            control={<Index.Radio />}
                                            label="No (ના)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>
                                    </Index.Grid>

                                    {values?.mediclaimPremiumAssistance ===
                                      "yes" && (
                                      <Index.Grid item xs={12} sm={6}>
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Amount (રકમ)
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            type="number"
                                            name="mediclaimPremiumAmount"
                                            value={
                                              values?.mediclaimPremiumAmount ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    )}

                                    <Index.Grid item xs={12} sm={6}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Have you received medicine/hospital
                                          assistance from the organization in
                                          last 12 months? (શું તમે છેલ્લા 12
                                          મહિનામાં સંસ્થા પાસેથી દવા/હોસ્પિટલ
                                          સહાય મેળવી છે?)
                                        </Index.Typography>
                                        <Index.RadioGroup
                                          row
                                          name="receivedMedicineAssistanceLast12Months"
                                          value={
                                            values?.receivedMedicineAssistanceLast12Months ||
                                            ""
                                          }
                                          onChange={handleChange}
                                        >
                                          <Index.FormControlLabel
                                            value="yes"
                                            control={<Index.Radio />}
                                            label="Yes (હા)"
                                          />
                                          <Index.FormControlLabel
                                            value="no"
                                            control={<Index.Radio />}
                                            label="No (ના)"
                                          />
                                        </Index.RadioGroup>
                                      </Index.Box>
                                    </Index.Grid>

                                    {values?.receivedMedicineAssistanceLast12Months ===
                                      "yes" && (
                                      <Index.Grid item xs={12} sm={6}>
                                        <Index.Box className="lable-input-grp">
                                          <Index.Typography
                                            component="p"
                                            className="in-label"
                                          >
                                            Amount (રકમ)
                                          </Index.Typography>
                                          <Index.TextField
                                            fullWidth
                                            type="number"
                                            name="medicineAssistanceAmount"
                                            value={
                                              values?.medicineAssistanceAmount ||
                                              ""
                                            }
                                            onChange={handleChange}
                                          />
                                        </Index.Box>
                                      </Index.Grid>
                                    )}
                                  </Index.Grid>
                                </Index.Box>

                                {/* Known Person Details */}
                                {/* <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Known Person in Community (સમુદાયમાં
                                      જાણીતી વ્યક્તિ)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Grid container spacing={2}>
                                    <Index.Grid item xs={12} sm={6} md={3}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Full Name (પુરું નામ)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="knownPersonFullName"
                                          value={
                                            values?.knownPersonFullName || ""
                                          }
                                          onChange={handleChange}
                                          onBlur={handleBlur}
                                        />
                                        {errors?.knownPersonFullName &&
                                          touched?.knownPersonFullName && (
                                            <p className="error-text">
                                              {errors?.knownPersonFullName}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={3}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Residence (નિવાસ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="knownPersonResidence"
                                          value={
                                            values?.knownPersonResidence || ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={3}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Neighborhood (પડોશ)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          name="knownPersonNeighborhood"
                                          value={
                                            values?.knownPersonNeighborhood ||
                                            ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={3}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Home Phone (ઘરનો ફોન)
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="tel"
                                          name="knownPersonHomePhone"
                                          value={
                                            values?.knownPersonHomePhone || ""
                                          }
                                          onChange={handleChange}
                                        />
                                      </Index.Box>
                                    </Index.Grid>

                                    <Index.Grid item xs={12} sm={6} md={3}>
                                      <Index.Box className="lable-input-grp">
                                        <Index.Typography
                                          component="p"
                                          className="in-label"
                                        >
                                          Mobile (મોબાઇલ)
                                          <span className="required">*</span>
                                        </Index.Typography>
                                        <Index.TextField
                                          fullWidth
                                          type="tel"
                                          name="knownPersonMobile"
                                          value={
                                            values?.knownPersonMobile || ""
                                          }
                                          onChange={(e) => {
                                            const value = e.target.value
                                              .replace(/\D/g, "")
                                              .slice(0, 10);
                                            setFieldValue(
                                              "knownPersonMobile",
                                              value,
                                            );
                                          }}
                                          onBlur={handleBlur}
                                        />
                                        {errors?.knownPersonMobile &&
                                          touched?.knownPersonMobile && (
                                            <p className="error-text">
                                              {errors?.knownPersonMobile}
                                            </p>
                                          )}
                                      </Index.Box>
                                    </Index.Grid>
                                  </Index.Grid>
                                </Index.Box> */}

                                {/* Detailed Bills Section */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      Detailed Bills (વિગતવાર બિલો)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Typography
                                    sx={{
                                      mb: 2,
                                      fontSize: "14px",
                                      color: "#666",
                                    }}
                                  >
                                    Note: Original bills of total medicine
                                    costs, xerox of hospital bills with xerox of
                                    doctor's prescriptions, xerox of hospital
                                    reports, xerox of Mediclaim policy, xerox of
                                    hospital discharge card, and detailed
                                    information of other expenses must be filled
                                    below.
                                  </Index.Typography>

                                  {/* A. Medicine Bills */}
                                  <Index.Typography
                                    variant="h6"
                                    sx={{ mt: 3, mb: 2 }}
                                  >
                                    A. Details of Medicine Bills (દવાના બિલોની
                                    વિગત)
                                  </Index.Typography>

                                  <Index.TableContainer
                                    component={Index.Paper}
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Table>
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>
                                            Medical Store Name (મેડિકલ સ્ટોરનું
                                            નામ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Date (તારીખ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Amount (રકમ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        
                                      <PagesIndex.FieldArray name="medicineBillsDetails">
                                          {({ push, remove }) => {
                                            const totalMedicineAmount =
                                                values?.medicineBillsDetails?.reduce(
                                                  (sum, item) => sum + Number(item.amount || 0),
                                                  0
                                                ) || 0;
                                            return(
                                              <>
                                                {values?.medicineBillsDetails?.map(
                                                  (bill, index) => (
                                                    <Index.TableRow key={index}>
                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          fullWidth
                                                          name={`medicineBillsDetails.${index}.medicalStoreName`}
                                                          value={
                                                            values
                                                              .medicineBillsDetails[
                                                              index
                                                            ]?.medicalStoreName ||
                                                            ""
                                                          }
                                                          onChange={handleChange}
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.LocalizationProvider
                                                          dateAdapter={
                                                            Index.AdapterDayjs
                                                          }
                                                        >
                                                          <Index.DatePicker
                                                            value={
                                                              bill.date
                                                                ? dayjs(bill.date)
                                                                : null
                                                            }
                                                            onChange={(value) => {
                                                              setFieldValue(
                                                                `medicineBillsDetails.${index}.date`,
                                                                value
                                                                  ? value.format(
                                                                      "YYYY-MM-DD",
                                                                    )
                                                                  : "",
                                                              );
                                                            }}
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                              textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                              },
                                                            }}
                                                          />
                                                        </Index.LocalizationProvider>
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          name={`medicineBillsDetails.${index}.amount`}
                                                          value={
                                                            values
                                                              .medicineBillsDetails[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={handleChange}
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )}

                                                  {/* Total Row */}
                                                  <Index.TableRow>
                                                    <Index.TableCell colSpan={2}></Index.TableCell>
                                                    <Index.TableCell>
                                                      <b>Total</b>
                                                    </Index.TableCell>

                                                    <Index.TableCell>
                                                      <b>{totalMedicineAmount}</b>
                                                    </Index.TableCell>
                                                  </Index.TableRow>

                                                {/* Add Row */} 
                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={4}>
                                                    <Index.Button
                                                      variant="outlined"
                                                      onClick={() =>
                                                        push({
                                                          date: "",
                                                          amount: "",
                                                          medicalStoreName: "",
                                                        })
                                                      }
                                                      fullWidth
                                                    >
                                                      + Add Medicine Bill
                                                    </Index.Button>
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              </>
                                          )}}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>

                                  {/* B. Diagnosis Bills */}
                                  <Index.Typography
                                    variant="h6"
                                    sx={{ mt: 3, mb: 2 }}
                                  >
                                    B. Details of Diagnosis (Lab, X-ray, etc.)
                                    [નિદાનની વિગત (લેબ, એક્સ-રે વગેરે)]
                                  </Index.Typography>

                                  <Index.TableContainer
                                    component={Index.Paper}
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Table>
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>
                                            Laboratory Name (પ્રયોગશાળાનું
                                            નામ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Date (તારીખ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Amount (રકમ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="diagnosisBillsDetails">
                                          {({ push, remove }) => {
                                            const totalDiagnosiseAmount =
                                            values?.diagnosisBillsDetails?.reduce(
                                              (sum, item) => sum + Number(item.amount || 0),
                                              0
                                            ) || 0;

                                            return(
                                              <>
                                                {values?.diagnosisBillsDetails?.map(
                                                  (bill, index) => (
                                                    <Index.TableRow key={index}>
                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          fullWidth
                                                          name={`diagnosisBillsDetails.${index}.laboratoryName`}
                                                          value={
                                                            values
                                                              .diagnosisBillsDetails[
                                                              index
                                                            ]?.laboratoryName ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.LocalizationProvider
                                                          dateAdapter={
                                                            Index.AdapterDayjs
                                                          }
                                                        >
                                                          <Index.DatePicker
                                                            value={
                                                              bill.date
                                                                ? dayjs(
                                                                    bill.date,
                                                                  )
                                                                : null
                                                            }
                                                            onChange={(
                                                              value,
                                                            ) => {
                                                              setFieldValue(
                                                                `diagnosisBillsDetails.${index}.date`,
                                                                value
                                                                  ? value.format(
                                                                      "YYYY-MM-DD",
                                                                    )
                                                                  : "",
                                                              );
                                                            }}
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                              textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                              },
                                                            }}
                                                          />
                                                        </Index.LocalizationProvider>
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          name={`diagnosisBillsDetails.${index}.amount`}
                                                          value={
                                                            values
                                                              .diagnosisBillsDetails[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )}
                                                
                                                {/* Total Row */}
                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={2}></Index.TableCell>
                                                  <Index.TableCell>
                                                    <b>Total</b>
                                                  </Index.TableCell>

                                                  <Index.TableCell>
                                                    <b>{totalDiagnosiseAmount}</b>
                                                  </Index.TableCell>
                                                </Index.TableRow>

                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={4}>
                                                    <Index.Button
                                                      variant="outlined"
                                                      onClick={() =>
                                                        push({
                                                          date: "",
                                                          laboratoryName: "",
                                                          amount: "",
                                                        })
                                                      }
                                                      fullWidth
                                                    >
                                                      + Add Diagnosis Bill
                                                    </Index.Button>
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              </>
                                          )}}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>

                                  {/* C. Hospital Bills */}
                                  <Index.Typography
                                    variant="h6"
                                    sx={{ mt: 3, mb: 2 }}
                                  >
                                    C. Details of Hospital, Operation, etc.
                                    (હોસ્પિટલ, ઓપરેશન વગેરેની વિગત)
                                  </Index.Typography>

                                  <Index.TableContainer
                                    component={Index.Paper}
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Table>
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>
                                            Details (વિગત)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Date (તારીખ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Amount (રકમ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="hospitalBillsDetails">
                                          {({ push, remove }) => {
                                            const totalHospitalAmount =
                                            values?.hospitalBillsDetails?.reduce(
                                              (sum, item) => sum + Number(item.amount || 0),
                                              0
                                            ) || 0;

                                            return(
                                              <>
                                                {values?.hospitalBillsDetails?.map(
                                                  (bill, index) => (
                                                    <Index.TableRow key={index}>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          fullWidth
                                                          name={`hospitalBillsDetails.${index}.details`}
                                                          value={
                                                            values
                                                              .hospitalBillsDetails[
                                                              index
                                                            ]?.details || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.LocalizationProvider
                                                          dateAdapter={
                                                            Index.AdapterDayjs
                                                          }
                                                        >
                                                          <Index.DatePicker
                                                            value={
                                                              bill.date
                                                                ? dayjs(
                                                                    bill.date,
                                                                  )
                                                                : null
                                                            }
                                                            onChange={(
                                                              value,
                                                            ) => {
                                                              setFieldValue(
                                                                `hospitalBillsDetails.${index}.date`,
                                                                value
                                                                  ? value.format(
                                                                      "YYYY-MM-DD",
                                                                    )
                                                                  : "",
                                                              );
                                                            }}
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                              textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                              },
                                                            }}
                                                          />
                                                        </Index.LocalizationProvider>
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          name={`hospitalBillsDetails.${index}.amount`}
                                                          value={
                                                            values
                                                              .hospitalBillsDetails[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )}

                                                {/* Total Row */}
                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={2}></Index.TableCell>
                                                  <Index.TableCell>
                                                    <b>Total</b>
                                                  </Index.TableCell>

                                                  <Index.TableCell>
                                                    <b>{totalHospitalAmount}</b>
                                                  </Index.TableCell>
                                                </Index.TableRow>


                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={4}>
                                                    <Index.Button
                                                      variant="outlined"
                                                      onClick={() =>
                                                        push({
                                                          date: "",
                                                          details: "",
                                                          amount: "",
                                                        })
                                                      }
                                                      fullWidth
                                                    >
                                                      + Add Hospital Bill
                                                    </Index.Button>
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              </>
                                          )}}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>

                                  {/* D. Other Expenses */}
                                  <Index.Typography
                                    variant="h6"
                                    sx={{ mt: 3, mb: 2 }}
                                  >
                                    D. Details of Other Expenses (અન્ય ખર્ચાની
                                    વિગત)
                                  </Index.Typography>

                                  <Index.TableContainer
                                    component={Index.Paper}
                                    sx={{ mb: 3 }}
                                  >
                                    <Index.Table>
                                      <Index.TableHead>
                                        <Index.TableRow>
                                          <Index.TableCell>
                                            Details (વિગત)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Date (તારીખ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Amount (રકમ)
                                          </Index.TableCell>
                                          <Index.TableCell>
                                            Action
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody>
                                        <PagesIndex.FieldArray name="otherExpensesDetails">
                                          {({ push, remove }) => {
                                            const totalExpensesAmount =
                                            values?.otherExpensesDetails?.reduce(
                                              (sum, item) => sum + Number(item.amount || 0),
                                              0
                                            ) || 0;

                                            return(
                                              <>
                                                {values?.otherExpensesDetails?.map(
                                                  (expense, index) => (
                                                    <Index.TableRow key={index}>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          fullWidth
                                                          name={`otherExpensesDetails.${index}.details`}
                                                          value={
                                                            values
                                                              .otherExpensesDetails[
                                                              index
                                                            ]?.details || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.LocalizationProvider
                                                          dateAdapter={
                                                            Index.AdapterDayjs
                                                          }
                                                        >
                                                          <Index.DatePicker
                                                            value={
                                                              expense.date
                                                                ? dayjs(
                                                                    expense.date,
                                                                  )
                                                                : null
                                                            }
                                                            onChange={(
                                                              value,
                                                            ) => {
                                                              setFieldValue(
                                                                `otherExpensesDetails.${index}.date`,
                                                                value
                                                                  ? value.format(
                                                                      "YYYY-MM-DD",
                                                                    )
                                                                  : "",
                                                              );
                                                            }}
                                                            format="YYYY-MM-DD"
                                                            slotProps={{
                                                              textField: {
                                                                size: "small",
                                                                fullWidth: true,
                                                              },
                                                            }}
                                                          />
                                                        </Index.LocalizationProvider>
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          name={`otherExpensesDetails.${index}.amount`}
                                                          value={
                                                            values
                                                              .otherExpensesDetails[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      

                                                      <Index.TableCell>
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )}

                                                {/* Total Row */}
                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={2}></Index.TableCell>
                                                  <Index.TableCell>
                                                    <b>Total</b>
                                                  </Index.TableCell>

                                                  <Index.TableCell>
                                                    <b>{totalExpensesAmount}</b>
                                                  </Index.TableCell>
                                                </Index.TableRow>


                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={4}>
                                                    <Index.Button
                                                      variant="outlined"
                                                      onClick={() =>
                                                        push({
                                                          date: "",
                                                          details: "",
                                                          amount: "",
                                                        })
                                                      }
                                                      fullWidth
                                                    >
                                                      + Add Other Expense
                                                    </Index.Button>
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              </>
                                          )}}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>

                                  {/* Total Sum Display */}
                                  <Index.Box
                                    sx={{
                                      mt: 3,
                                      p: 2,
                                      bgcolor: "#f5f5f5",
                                      borderRadius: 1,
                                      textAlign: "right",
                                    }}
                                  >
                                    <Index.Typography variant="h6">
                                      Total sum of expenses (A + B + C + D): Rs.{" "}
                                      {(() => {
                                        const medicineTotal =
                                          values?.medicineBillsDetails?.reduce(
                                            (sum, bill) =>
                                              sum +
                                              (parseFloat(bill.amount) || 0),
                                            0,
                                          );
                                        const diagnosisTotal =
                                          values?.diagnosisBillsDetails?.reduce(
                                            (sum, bill) =>
                                              sum +
                                              (parseFloat(bill.amount) || 0),
                                            0,
                                          );
                                        const hospitalTotal =
                                          values?.hospitalBillsDetails?.reduce(
                                            (sum, bill) =>
                                              sum +
                                              (parseFloat(bill.amount) || 0),
                                            0,
                                          );
                                        const otherTotal =
                                          values?.otherExpensesDetails?.reduce(
                                            (sum, expense) =>
                                              sum +
                                              (parseFloat(expense.amount) || 0),
                                            0,
                                          );
                                        return (
                                          medicineTotal +
                                          diagnosisTotal +
                                          hospitalTotal +
                                          otherTotal
                                        ).toFixed(2);
                                      })()}
                                    </Index.Typography>
                                  </Index.Box>
                                </Index.Box>

                                {/* External Assistance Details */}
                                <Index.Box className="main-in-row main-card-box">
                                  <Index.Box className="user-basic">
                                    <Index.Typography
                                      component="p"
                                      className="head-apply"
                                    >
                                      External Assistance Details (બાહ્ય સહાયની
                                      વિગત)
                                    </Index.Typography>
                                  </Index.Box>

                                  <Index.Box sx={{ mb: 2 }}>
                                    <Index.Typography
                                      component="p"
                                      sx={{ mb: 1 }}
                                    >
                                      Has the applicant received assistance from
                                      other organizations or unions for this
                                      treatment?
                                      <br />
                                      (શું અરજદારને આ સારવાર માટે અન્ય સંસ્થાઓ
                                      અથવા યુનિયનો પાસેથી સહાય મળી છે?)
                                    </Index.Typography>

                                    <Index.RadioGroup
                                      row
                                      name="receivedExternalAssistance"
                                      value={
                                        values?.receivedExternalAssistance || ""
                                      }
                                      onChange={handleChange}
                                    >
                                      <Index.FormControlLabel
                                        value="yes"
                                        control={<Index.Radio />}
                                        label="Yes (હા)"
                                      />
                                      <Index.FormControlLabel
                                        value="no"
                                        control={<Index.Radio />}
                                        label="No (ના)"
                                      />
                                    </Index.RadioGroup>
                                  </Index.Box>

                                  {values?.receivedExternalAssistance ===
                                    "yes" && (
                                    <Index.TableContainer
                                      component={Index.Paper}
                                    >
                                      <Index.Table>
                                        <Index.TableHead>
                                          <Index.TableRow>
                                            <Index.TableCell>
                                              No.
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Full Name of Organization or Union
                                              (સંસ્થા અથવા યુનિયનનું પુરું નામ)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Assistance Amount (સહાય રકમ)
                                            </Index.TableCell>
                                            <Index.TableCell>
                                              Action
                                            </Index.TableCell>
                                          </Index.TableRow>
                                        </Index.TableHead>
                                        <Index.TableBody>
                                          <PagesIndex.FieldArray name="externalAssistanceDetails">
                                            {({ push, remove }) => (
                                              <>
                                                {values?.externalAssistanceDetails?.map(
                                                  (assistance, index) => (
                                                    <Index.TableRow key={index}>
                                                      <Index.TableCell>
                                                        {index + 1}
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          fullWidth
                                                          name={`externalAssistanceDetails.${index}.organizationName`}
                                                          value={
                                                            values
                                                              .externalAssistanceDetails[
                                                              index
                                                            ]
                                                              ?.organizationName ||
                                                            ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          placeholder="Organization Name"
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        <Index.TextField
                                                          size="small"
                                                          type="number"
                                                          fullWidth
                                                          name={`externalAssistanceDetails.${index}.amount`}
                                                          value={
                                                            values
                                                              .externalAssistanceDetails[
                                                              index
                                                            ]?.amount || ""
                                                          }
                                                          onChange={
                                                            handleChange
                                                          }
                                                          placeholder="Amount"
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell>
                                                        {index > 0 && (
                                                          <Index.IconButton
                                                            onClick={() =>
                                                              remove(index)
                                                            }
                                                            color="error"
                                                            size="small"
                                                          >
                                                            <Index.DeleteIcon />
                                                          </Index.IconButton>
                                                        )}
                                                      </Index.TableCell>
                                                    </Index.TableRow>
                                                  ),
                                                )}

                                                <Index.TableRow>
                                                  <Index.TableCell colSpan={4}>
                                                    <Index.Button
                                                      variant="outlined"
                                                      onClick={() =>
                                                        push({
                                                          organizationName: "",
                                                          amount: "",
                                                        })
                                                      }
                                                      fullWidth
                                                    >
                                                      + Add Organization
                                                    </Index.Button>
                                                  </Index.TableCell>
                                                </Index.TableRow>
                                              </>
                                            )}
                                          </PagesIndex.FieldArray>
                                        </Index.TableBody>
                                      </Index.Table>
                                    </Index.TableContainer>
                                  )}
                                </Index.Box>
                              </>
                            )}

                            {(values?.subSahayName?.toLowerCase() == "hospitalisation sahay" || values?.subSahayName?.toLowerCase() == "medical sahay") && (
                              <>
                                {/* General Note */}
                                <Index.Box
                                  className="special-note"
                                  sx={{
                                    mb: 3,
                                    p: 2,
                                    bgcolor: "#fff3cd",
                                    borderRadius: 1,
                                    border: "1px solid #ffc107",
                                  }}
                                >
                                  <Index.Typography
                                    sx={{
                                      fontWeight: "bold",
                                      color: "#856404",
                                      mb: 1,
                                    }}
                                  >
                                    General Note (સામાન્ય નોંધ):
                                  </Index.Typography>
                                  <Index.Typography sx={{ color: "#856404" }}>
                                    Please send all medicine bills with prescription   
                                    Patan jain mandal marine drive office, without prescription, sahay form will not be approve.
                                    <br />
                                    (કૃપા કરીને બધા દવાના બિલ પ્રિસ્ક્રિપ્શન સાથે મોકલો 
                                      પાટણ જૈન મંડલ મરીન ડ્રાઇવ ઓફિસ, પ્રિસ્ક્રિપ્શન વિના, 
                                      સહાય ફોર્મ મંજૂર કરવામાં આવશે નહીં.)
                                  </Index.Typography>
                                </Index.Box>
                              </>
                            )}

                            <Index.Box className="field-table">
                              <Index.Grid>
                                <Index.Box className="">
                                  <Index.TableContainer
                                    component={Index.Paper}
                                    className="table-container edit-drop-container"
                                  >
                                    <Index.Table
                                      aria-label="simple table"
                                      className="table-design-main barge-table edit-drop-table"
                                    >
                                      <Index.TableHead className="edit-drop-head">
                                        <Index.TableRow className="edit-drop-tr">
                                          <Index.TableCell
                                            align="left"
                                            className="edit-drop-td"
                                          >
                                            Name (નામ)
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="edit-drop-td"
                                          >
                                            Relation (સંબંધ)
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="edit-drop-td"
                                          >
                                            Age (ઉંમર)
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="edit-drop-td"
                                          >
                                            {/* Working Type (કામ કરવાનો પ્રકાર) */}
                                            Occupation (વ્યવસાય)
                                          </Index.TableCell>
                                          {/* <Index.TableCell
                                            align="left"
                                            className="edit-drop-td"
                                          >
                                            Monthly Income
                                          </Index.TableCell> */}
                                          <Index.TableCell align="left">
                                            Income(Per Month) [આવક (દર મહિને)]
                                          </Index.TableCell>
                                        </Index.TableRow>
                                      </Index.TableHead>
                                      <Index.TableBody className="edit-drop-tbody">
                                        <Index.TableRow className="edit-drop-tr">
                                          <Index.TableCell
                                            align="left"
                                            className="tablecell edit-drop-td"
                                          >
                                            <Index.TextField
                                              placeholder="Name"
                                              small
                                              disabled
                                              inputProps={ariaLabel}
                                              className="tablecell-field"
                                              value={
                                                values?.memberName
                                                  ? values?.memberName
                                                  : applicantSelectedMember[0]
                                                    ? applicantSelectedMember[0]
                                                        ?.firstName +
                                                      " " +
                                                      applicantSelectedMember[0]
                                                        ?.middleName +
                                                      " " +
                                                      applicantSelectedMember[0]
                                                        ?.lastName
                                                    : ""
                                              }
                                            />
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="tablecell edit-drop-td"
                                          >
                                            <Index.TextField
                                              placeholder="Relation"
                                              small
                                              inputProps={ariaLabel}
                                              className="tablecell-field"
                                              disabled
                                              value={
                                                applicantSelectedMember[0]
                                                  ?.relation
                                                  ? "Applicant"
                                                  : values?.relation
                                              }
                                            />
                                          </Index.TableCell>

                                          <Index.TableCell
                                            align="left"
                                            className="tablecell edit-drop-td"
                                          >
                                            <Index.TextField
                                              placeholder="Age"
                                              small
                                              disabled
                                              inputProps={ariaLabel}
                                              className="tablecell-field"
                                              value={
                                                values?.age
                                                  ? values?.age
                                                  : applicantSelectedMember[0]
                                                      ?.age
                                              }
                                            />
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="tablecell edit-drop-td"
                                          >
                                            {/* <Index.TextField
                                              small
                                              inputProps={ariaLabel}
                                              name="workingType"
                                              className="tablecell-field"
                                              onChange={handleChange}
                                              value={
                                                values?.workingType
                                                  ? values?.workingType
                                                  : applicantSelectedMember[0]
                                                      ?.workingType
                                              }
                                              disabled
                                              placeholder="Job"
                                            /> */}
                                            <Index.Box className="input-design-div with-border">
                                              <Index.Select
                                                hiddenLabel
                                                fullWidth
                                                id="hghsdf"
                                                value={values?.workingType}
                                                name={`workingType`}
                                                onChange={handleChange}
                                              >
                                                {workingTypeList?.map((ele) => (
                                                  <Index.MenuItem
                                                    key={ele?.id}
                                                    value={ele?.name}
                                                  >
                                                    {ele?.name}
                                                  </Index.MenuItem>
                                                ))}
                                              </Index.Select>
                                            </Index.Box>
                                          </Index.TableCell>
                                          <Index.TableCell
                                            align="left"
                                            className="tablecell edit-drop-td"
                                          >
                                            <Index.TextField
                                              small
                                              name="newMonthlyIncome"
                                              inputProps={ariaLabel}
                                              className="tablecell-field"
                                              // value={
                                              //   applicantSelectedMember[0]
                                              //     ?.AnnualIncome
                                              // }
                                              value={
                                                values?.newMonthlyIncome || 0
                                              }
                                              onChange={handleChange}
                                              placeholder="Monthly Income"
                                            />
                                          </Index.TableCell>
                                        </Index.TableRow>

                                        <PagesIndex.FieldArray name="relationRecords">
                                          {({ push, remove }) => (
                                            <>
                                              <>
                                                {values?.relationRecords?.map(
                                                  (data, index) => (
                                                    <Index.TableRow className="edit-drop-tr">
                                                      <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        <Index.TextField
                                                          placeholder="Name"
                                                          small
                                                          inputProps={ariaLabel}
                                                          name={`relationRecords.${index}.firstName`}
                                                          className="tablecell-field"
                                                          onChange={
                                                            handleChange
                                                          }
                                                          value={
                                                            values
                                                              .relationRecords[
                                                              index
                                                            ].firstName
                                                            // +
                                                            // " " +
                                                            // values
                                                            //   .relationRecords[
                                                            //   index
                                                            // ].middleName +
                                                            // " " +
                                                            // values
                                                            //   .relationRecords[
                                                            //   index
                                                            // ].lastName
                                                          }
                                                        />
                                                      </Index.TableCell>

                                                      <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        <Index.Box className="input-design-div with-border">
                                                          <Index.Select
                                                            hiddenLabel
                                                            fullWidth
                                                            id="hgh"
                                                            name={`relationRecords.${index}.relation_id`}
                                                            onBlur={handleBlur}
                                                            onChange={
                                                              handleChange
                                                            }
                                                            value={
                                                              values
                                                                .relationRecords[
                                                                index
                                                              ].relation_id
                                                            }
                                                          >
                                                            {getRelationList &&
                                                              getRelationList?.map(
                                                                (option) => (
                                                                  <Index.MenuItem
                                                                    key={
                                                                      option.relation_id
                                                                    }
                                                                    value={
                                                                      option.relation_id
                                                                    }
                                                                    name={
                                                                      option.relation_name
                                                                    }
                                                                  >
                                                                    {
                                                                      option.relation_name
                                                                    }
                                                                  </Index.MenuItem>
                                                                ),
                                                              )}
                                                          </Index.Select>
                                                        </Index.Box>
                                                      </Index.TableCell>

                                                      <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        <Index.TextField
                                                          placeholder="Age"
                                                          small
                                                          inputProps={ariaLabel}
                                                          className="tablecell-field"
                                                          value={
                                                            values
                                                              .relationRecords[
                                                              index
                                                            ].age
                                                          }
                                                          name={`relationRecords.${index}.age`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>
                                                      <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        {/* <Index.TextField
                                                          placeholder="Job"
                                                          small
                                                          inputProps={ariaLabel}
                                                          className="tablecell-field"
                                                          value={
                                                            values
                                                              .relationRecords[
                                                              index
                                                            ].workingType
                                                          }
                                                          name={`relationRecords.${index}.workingType`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                        /> */}
                                                        <Index.Box className="input-design-div with-border">
                                                          <Index.Select
                                                            hiddenLabel
                                                            fullWidth
                                                            id="hghsdf"
                                                            value={
                                                              values
                                                                .relationRecords[
                                                                index
                                                              ].workingType
                                                            }
                                                            name={`relationRecords.${index}.workingType`}
                                                            onChange={
                                                              handleChange
                                                            }
                                                          >
                                                            {workingTypeList?.map(
                                                              (ele) => (
                                                                <Index.MenuItem
                                                                  key={ele?.id}
                                                                  value={
                                                                    ele?.name
                                                                  }
                                                                >
                                                                  {ele?.name}
                                                                </Index.MenuItem>
                                                              ),
                                                            )}
                                                          </Index.Select>
                                                        </Index.Box>
                                                      </Index.TableCell>
                                                      <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        <Index.TextField
                                                          type="number"
                                                          small
                                                          inputProps={ariaLabel}
                                                          className="tablecell-field"
                                                          placeholder="Monthly Income"
                                                          value={
                                                            values
                                                              .relationRecords[
                                                              index
                                                            ]
                                                              .newMonthlyIncome ||
                                                            0
                                                          }
                                                          name={`relationRecords.${index}.newMonthlyIncome`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell>
                                                      {/* <Index.TableCell
                                                        align="left"
                                                        className="tablecell edit-drop-td"
                                                      >
                                                        <Index.TextField
                                                          type="number"
                                                          small
                                                          inputProps={ariaLabel}
                                                          className="tablecell-field"
                                                          placeholder="Monthly Income"
                                                          value={
                                                            values
                                                              .relationRecords[
                                                              index
                                                            ].AnnualIncome
                                                          }
                                                          name={`relationRecords.${index}.AnnualIncome`}
                                                          onChange={
                                                            handleChange
                                                          }
                                                        />
                                                      </Index.TableCell> */}
                                                    </Index.TableRow>
                                                  ),
                                                )}
                                              </>
                                            </>
                                          )}
                                        </PagesIndex.FieldArray>
                                      </Index.TableBody>
                                    </Index.Table>
                                  </Index.TableContainer>
                                </Index.Box>
                              </Index.Grid>
                            </Index.Box>
                            <Index.Box
                              sx={{ flexGrow: 1 }}
                              className="al-form-groups fam-in-grp"
                            >
                              <Index.Grid container spacing={2}>
                                <Index.Grid item xs={3}>
                                  <Index.Box className="lable-input-grp ">
                                    <Index.Box className="select-position">
                                      <Index.Box
                                        className={
                                          values?.isSubmit === false
                                            ? "apply-now"
                                            : "disable-now"
                                        }
                                      >
                                        <button
                                          onClick={() => {
                                            setFieldValue("isDraft", 0);
                                            setSaveValue(true);
                                          }}
                                          type="submit"
                                          disabled={values?.isSubmit}
                                        >
                                          Save As Draft
                                        </button>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={3}>
                                  <Index.Box className="lable-input-grp ">
                                    <Index.Box className="select-position">
                                      <Index.Box
                                        className={
                                          values?.isSubmit === false
                                            ? "apply-now"
                                            : "disable-now"
                                        }
                                      >
                                        <button
                                          type="submit"
                                          onClick={() => {
                                            setFieldValue("isDraft", 1);
                                            setSaveValue(false);
                                          }}
                                          disabled={values?.isSubmit}
                                        >
                                          Submit Sahay Application
                                        </button>
                                      </Index.Box>
                                    </Index.Box>
                                  </Index.Box>
                                </Index.Grid>
                                <Index.Grid item xs={6}>
                                  <Index.Box className="common-button blue-button flex-end save-btn back-btn">
                                    <Index.Button
                                      variant="contained"
                                      onClick={() => handleBack()}
                                    >
                                      Back
                                    </Index.Button>
                                  </Index.Box>
                                </Index.Grid>
                              </Index.Grid>
                            </Index.Box>
                          </Index.Box>{" "}
                        </form>
                      )}
                    </PagesIndex.Formik>

                    <Index.Box className="title-header-flex "></Index.Box>
                  </Index.Box>
                </Index.Box>
              </Index.Box>
            </Index.Box>
          ) : (
            <Index.Box className="circular-loading">
              <Index.CircularProgress />
            </Index.Box>
            // <PagesIndex.PageLoading colSpan={12} />
          )}
        </Index.Box>
        {/* // ) : ( // <h1>Loading...</h1>
        // )} */}
      </div>

      <AfterSumitFormModal
        openModalAfterSubmit={openModalAfterSubmit}
        handleCloseAftereSubmitModal={handleCloseAftereSubmitModal}
        saveVale={saveVale}
      />
    </>
  );
};
export default EditApplyForSahay;
